webpackJsonp([1],{

/***/ 115:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 184:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 185:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 226:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ([{
  // 社会
  cid: 2,
  label: 'สังคม'
}, {
  // 娱乐
  cid: 3,
  label: 'บันเทิง'
}, {
  // 国际
  cid: 4,
  label: 'ต่างประเทศ'
}, {
  // 运动
  cid: 5,
  label: 'กีฬา'
}, {
  // 经济
  cid: 6,
  label: 'เศรษฐกิจ'
}, {
  // 科技
  cid: 7,
  label: 'เทคโนโลยี'
}, {
  // 时尚
  cid: 8,
  label: 'แฟชั่น'
}, {
  // 旅游
  cid: 10,
  label: 'ท่องเที่ยว'
}, {
  // 游戏
  cid: 11,
  label: 'เกม'
}, {
  // 健康
  cid: 12,
  label: 'สุขภาพ'
}, {
  // 美食
  cid: 13,
  label: 'อาหาร'
}, {
  // 汽车
  cid: 14,
  label: 'ยานยนต์'
}, {
  // 情感
  cid: 18,
  label: 'อารมณ์'
}, {
  // 生活
  cid: 19,
  label: 'ไลฟ์สไตล์'
}, {
  // 教育
  cid: 21,
  label: 'การศึกษา'
}]);

/***/ }),

/***/ 276:
/***/ (function(module, exports) {

module.exports = {"Aacute":"Á","aacute":"á","Abreve":"Ă","abreve":"ă","ac":"∾","acd":"∿","acE":"∾̳","Acirc":"Â","acirc":"â","acute":"´","Acy":"А","acy":"а","AElig":"Æ","aelig":"æ","af":"⁡","Afr":"𝔄","afr":"𝔞","Agrave":"À","agrave":"à","alefsym":"ℵ","aleph":"ℵ","Alpha":"Α","alpha":"α","Amacr":"Ā","amacr":"ā","amalg":"⨿","amp":"&","AMP":"&","andand":"⩕","And":"⩓","and":"∧","andd":"⩜","andslope":"⩘","andv":"⩚","ang":"∠","ange":"⦤","angle":"∠","angmsdaa":"⦨","angmsdab":"⦩","angmsdac":"⦪","angmsdad":"⦫","angmsdae":"⦬","angmsdaf":"⦭","angmsdag":"⦮","angmsdah":"⦯","angmsd":"∡","angrt":"∟","angrtvb":"⊾","angrtvbd":"⦝","angsph":"∢","angst":"Å","angzarr":"⍼","Aogon":"Ą","aogon":"ą","Aopf":"𝔸","aopf":"𝕒","apacir":"⩯","ap":"≈","apE":"⩰","ape":"≊","apid":"≋","apos":"'","ApplyFunction":"⁡","approx":"≈","approxeq":"≊","Aring":"Å","aring":"å","Ascr":"𝒜","ascr":"𝒶","Assign":"≔","ast":"*","asymp":"≈","asympeq":"≍","Atilde":"Ã","atilde":"ã","Auml":"Ä","auml":"ä","awconint":"∳","awint":"⨑","backcong":"≌","backepsilon":"϶","backprime":"‵","backsim":"∽","backsimeq":"⋍","Backslash":"∖","Barv":"⫧","barvee":"⊽","barwed":"⌅","Barwed":"⌆","barwedge":"⌅","bbrk":"⎵","bbrktbrk":"⎶","bcong":"≌","Bcy":"Б","bcy":"б","bdquo":"„","becaus":"∵","because":"∵","Because":"∵","bemptyv":"⦰","bepsi":"϶","bernou":"ℬ","Bernoullis":"ℬ","Beta":"Β","beta":"β","beth":"ℶ","between":"≬","Bfr":"𝔅","bfr":"𝔟","bigcap":"⋂","bigcirc":"◯","bigcup":"⋃","bigodot":"⨀","bigoplus":"⨁","bigotimes":"⨂","bigsqcup":"⨆","bigstar":"★","bigtriangledown":"▽","bigtriangleup":"△","biguplus":"⨄","bigvee":"⋁","bigwedge":"⋀","bkarow":"⤍","blacklozenge":"⧫","blacksquare":"▪","blacktriangle":"▴","blacktriangledown":"▾","blacktriangleleft":"◂","blacktriangleright":"▸","blank":"␣","blk12":"▒","blk14":"░","blk34":"▓","block":"█","bne":"=⃥","bnequiv":"≡⃥","bNot":"⫭","bnot":"⌐","Bopf":"𝔹","bopf":"𝕓","bot":"⊥","bottom":"⊥","bowtie":"⋈","boxbox":"⧉","boxdl":"┐","boxdL":"╕","boxDl":"╖","boxDL":"╗","boxdr":"┌","boxdR":"╒","boxDr":"╓","boxDR":"╔","boxh":"─","boxH":"═","boxhd":"┬","boxHd":"╤","boxhD":"╥","boxHD":"╦","boxhu":"┴","boxHu":"╧","boxhU":"╨","boxHU":"╩","boxminus":"⊟","boxplus":"⊞","boxtimes":"⊠","boxul":"┘","boxuL":"╛","boxUl":"╜","boxUL":"╝","boxur":"└","boxuR":"╘","boxUr":"╙","boxUR":"╚","boxv":"│","boxV":"║","boxvh":"┼","boxvH":"╪","boxVh":"╫","boxVH":"╬","boxvl":"┤","boxvL":"╡","boxVl":"╢","boxVL":"╣","boxvr":"├","boxvR":"╞","boxVr":"╟","boxVR":"╠","bprime":"‵","breve":"˘","Breve":"˘","brvbar":"¦","bscr":"𝒷","Bscr":"ℬ","bsemi":"⁏","bsim":"∽","bsime":"⋍","bsolb":"⧅","bsol":"\\","bsolhsub":"⟈","bull":"•","bullet":"•","bump":"≎","bumpE":"⪮","bumpe":"≏","Bumpeq":"≎","bumpeq":"≏","Cacute":"Ć","cacute":"ć","capand":"⩄","capbrcup":"⩉","capcap":"⩋","cap":"∩","Cap":"⋒","capcup":"⩇","capdot":"⩀","CapitalDifferentialD":"ⅅ","caps":"∩︀","caret":"⁁","caron":"ˇ","Cayleys":"ℭ","ccaps":"⩍","Ccaron":"Č","ccaron":"č","Ccedil":"Ç","ccedil":"ç","Ccirc":"Ĉ","ccirc":"ĉ","Cconint":"∰","ccups":"⩌","ccupssm":"⩐","Cdot":"Ċ","cdot":"ċ","cedil":"¸","Cedilla":"¸","cemptyv":"⦲","cent":"¢","centerdot":"·","CenterDot":"·","cfr":"𝔠","Cfr":"ℭ","CHcy":"Ч","chcy":"ч","check":"✓","checkmark":"✓","Chi":"Χ","chi":"χ","circ":"ˆ","circeq":"≗","circlearrowleft":"↺","circlearrowright":"↻","circledast":"⊛","circledcirc":"⊚","circleddash":"⊝","CircleDot":"⊙","circledR":"®","circledS":"Ⓢ","CircleMinus":"⊖","CirclePlus":"⊕","CircleTimes":"⊗","cir":"○","cirE":"⧃","cire":"≗","cirfnint":"⨐","cirmid":"⫯","cirscir":"⧂","ClockwiseContourIntegral":"∲","CloseCurlyDoubleQuote":"”","CloseCurlyQuote":"’","clubs":"♣","clubsuit":"♣","colon":":","Colon":"∷","Colone":"⩴","colone":"≔","coloneq":"≔","comma":",","commat":"@","comp":"∁","compfn":"∘","complement":"∁","complexes":"ℂ","cong":"≅","congdot":"⩭","Congruent":"≡","conint":"∮","Conint":"∯","ContourIntegral":"∮","copf":"𝕔","Copf":"ℂ","coprod":"∐","Coproduct":"∐","copy":"©","COPY":"©","copysr":"℗","CounterClockwiseContourIntegral":"∳","crarr":"↵","cross":"✗","Cross":"⨯","Cscr":"𝒞","cscr":"𝒸","csub":"⫏","csube":"⫑","csup":"⫐","csupe":"⫒","ctdot":"⋯","cudarrl":"⤸","cudarrr":"⤵","cuepr":"⋞","cuesc":"⋟","cularr":"↶","cularrp":"⤽","cupbrcap":"⩈","cupcap":"⩆","CupCap":"≍","cup":"∪","Cup":"⋓","cupcup":"⩊","cupdot":"⊍","cupor":"⩅","cups":"∪︀","curarr":"↷","curarrm":"⤼","curlyeqprec":"⋞","curlyeqsucc":"⋟","curlyvee":"⋎","curlywedge":"⋏","curren":"¤","curvearrowleft":"↶","curvearrowright":"↷","cuvee":"⋎","cuwed":"⋏","cwconint":"∲","cwint":"∱","cylcty":"⌭","dagger":"†","Dagger":"‡","daleth":"ℸ","darr":"↓","Darr":"↡","dArr":"⇓","dash":"‐","Dashv":"⫤","dashv":"⊣","dbkarow":"⤏","dblac":"˝","Dcaron":"Ď","dcaron":"ď","Dcy":"Д","dcy":"д","ddagger":"‡","ddarr":"⇊","DD":"ⅅ","dd":"ⅆ","DDotrahd":"⤑","ddotseq":"⩷","deg":"°","Del":"∇","Delta":"Δ","delta":"δ","demptyv":"⦱","dfisht":"⥿","Dfr":"𝔇","dfr":"𝔡","dHar":"⥥","dharl":"⇃","dharr":"⇂","DiacriticalAcute":"´","DiacriticalDot":"˙","DiacriticalDoubleAcute":"˝","DiacriticalGrave":"`","DiacriticalTilde":"˜","diam":"⋄","diamond":"⋄","Diamond":"⋄","diamondsuit":"♦","diams":"♦","die":"¨","DifferentialD":"ⅆ","digamma":"ϝ","disin":"⋲","div":"÷","divide":"÷","divideontimes":"⋇","divonx":"⋇","DJcy":"Ђ","djcy":"ђ","dlcorn":"⌞","dlcrop":"⌍","dollar":"$","Dopf":"𝔻","dopf":"𝕕","Dot":"¨","dot":"˙","DotDot":"⃜","doteq":"≐","doteqdot":"≑","DotEqual":"≐","dotminus":"∸","dotplus":"∔","dotsquare":"⊡","doublebarwedge":"⌆","DoubleContourIntegral":"∯","DoubleDot":"¨","DoubleDownArrow":"⇓","DoubleLeftArrow":"⇐","DoubleLeftRightArrow":"⇔","DoubleLeftTee":"⫤","DoubleLongLeftArrow":"⟸","DoubleLongLeftRightArrow":"⟺","DoubleLongRightArrow":"⟹","DoubleRightArrow":"⇒","DoubleRightTee":"⊨","DoubleUpArrow":"⇑","DoubleUpDownArrow":"⇕","DoubleVerticalBar":"∥","DownArrowBar":"⤓","downarrow":"↓","DownArrow":"↓","Downarrow":"⇓","DownArrowUpArrow":"⇵","DownBreve":"̑","downdownarrows":"⇊","downharpoonleft":"⇃","downharpoonright":"⇂","DownLeftRightVector":"⥐","DownLeftTeeVector":"⥞","DownLeftVectorBar":"⥖","DownLeftVector":"↽","DownRightTeeVector":"⥟","DownRightVectorBar":"⥗","DownRightVector":"⇁","DownTeeArrow":"↧","DownTee":"⊤","drbkarow":"⤐","drcorn":"⌟","drcrop":"⌌","Dscr":"𝒟","dscr":"𝒹","DScy":"Ѕ","dscy":"ѕ","dsol":"⧶","Dstrok":"Đ","dstrok":"đ","dtdot":"⋱","dtri":"▿","dtrif":"▾","duarr":"⇵","duhar":"⥯","dwangle":"⦦","DZcy":"Џ","dzcy":"џ","dzigrarr":"⟿","Eacute":"É","eacute":"é","easter":"⩮","Ecaron":"Ě","ecaron":"ě","Ecirc":"Ê","ecirc":"ê","ecir":"≖","ecolon":"≕","Ecy":"Э","ecy":"э","eDDot":"⩷","Edot":"Ė","edot":"ė","eDot":"≑","ee":"ⅇ","efDot":"≒","Efr":"𝔈","efr":"𝔢","eg":"⪚","Egrave":"È","egrave":"è","egs":"⪖","egsdot":"⪘","el":"⪙","Element":"∈","elinters":"⏧","ell":"ℓ","els":"⪕","elsdot":"⪗","Emacr":"Ē","emacr":"ē","empty":"∅","emptyset":"∅","EmptySmallSquare":"◻","emptyv":"∅","EmptyVerySmallSquare":"▫","emsp13":" ","emsp14":" ","emsp":" ","ENG":"Ŋ","eng":"ŋ","ensp":" ","Eogon":"Ę","eogon":"ę","Eopf":"𝔼","eopf":"𝕖","epar":"⋕","eparsl":"⧣","eplus":"⩱","epsi":"ε","Epsilon":"Ε","epsilon":"ε","epsiv":"ϵ","eqcirc":"≖","eqcolon":"≕","eqsim":"≂","eqslantgtr":"⪖","eqslantless":"⪕","Equal":"⩵","equals":"=","EqualTilde":"≂","equest":"≟","Equilibrium":"⇌","equiv":"≡","equivDD":"⩸","eqvparsl":"⧥","erarr":"⥱","erDot":"≓","escr":"ℯ","Escr":"ℰ","esdot":"≐","Esim":"⩳","esim":"≂","Eta":"Η","eta":"η","ETH":"Ð","eth":"ð","Euml":"Ë","euml":"ë","euro":"€","excl":"!","exist":"∃","Exists":"∃","expectation":"ℰ","exponentiale":"ⅇ","ExponentialE":"ⅇ","fallingdotseq":"≒","Fcy":"Ф","fcy":"ф","female":"♀","ffilig":"ﬃ","fflig":"ﬀ","ffllig":"ﬄ","Ffr":"𝔉","ffr":"𝔣","filig":"ﬁ","FilledSmallSquare":"◼","FilledVerySmallSquare":"▪","fjlig":"fj","flat":"♭","fllig":"ﬂ","fltns":"▱","fnof":"ƒ","Fopf":"𝔽","fopf":"𝕗","forall":"∀","ForAll":"∀","fork":"⋔","forkv":"⫙","Fouriertrf":"ℱ","fpartint":"⨍","frac12":"½","frac13":"⅓","frac14":"¼","frac15":"⅕","frac16":"⅙","frac18":"⅛","frac23":"⅔","frac25":"⅖","frac34":"¾","frac35":"⅗","frac38":"⅜","frac45":"⅘","frac56":"⅚","frac58":"⅝","frac78":"⅞","frasl":"⁄","frown":"⌢","fscr":"𝒻","Fscr":"ℱ","gacute":"ǵ","Gamma":"Γ","gamma":"γ","Gammad":"Ϝ","gammad":"ϝ","gap":"⪆","Gbreve":"Ğ","gbreve":"ğ","Gcedil":"Ģ","Gcirc":"Ĝ","gcirc":"ĝ","Gcy":"Г","gcy":"г","Gdot":"Ġ","gdot":"ġ","ge":"≥","gE":"≧","gEl":"⪌","gel":"⋛","geq":"≥","geqq":"≧","geqslant":"⩾","gescc":"⪩","ges":"⩾","gesdot":"⪀","gesdoto":"⪂","gesdotol":"⪄","gesl":"⋛︀","gesles":"⪔","Gfr":"𝔊","gfr":"𝔤","gg":"≫","Gg":"⋙","ggg":"⋙","gimel":"ℷ","GJcy":"Ѓ","gjcy":"ѓ","gla":"⪥","gl":"≷","glE":"⪒","glj":"⪤","gnap":"⪊","gnapprox":"⪊","gne":"⪈","gnE":"≩","gneq":"⪈","gneqq":"≩","gnsim":"⋧","Gopf":"𝔾","gopf":"𝕘","grave":"`","GreaterEqual":"≥","GreaterEqualLess":"⋛","GreaterFullEqual":"≧","GreaterGreater":"⪢","GreaterLess":"≷","GreaterSlantEqual":"⩾","GreaterTilde":"≳","Gscr":"𝒢","gscr":"ℊ","gsim":"≳","gsime":"⪎","gsiml":"⪐","gtcc":"⪧","gtcir":"⩺","gt":">","GT":">","Gt":"≫","gtdot":"⋗","gtlPar":"⦕","gtquest":"⩼","gtrapprox":"⪆","gtrarr":"⥸","gtrdot":"⋗","gtreqless":"⋛","gtreqqless":"⪌","gtrless":"≷","gtrsim":"≳","gvertneqq":"≩︀","gvnE":"≩︀","Hacek":"ˇ","hairsp":" ","half":"½","hamilt":"ℋ","HARDcy":"Ъ","hardcy":"ъ","harrcir":"⥈","harr":"↔","hArr":"⇔","harrw":"↭","Hat":"^","hbar":"ℏ","Hcirc":"Ĥ","hcirc":"ĥ","hearts":"♥","heartsuit":"♥","hellip":"…","hercon":"⊹","hfr":"𝔥","Hfr":"ℌ","HilbertSpace":"ℋ","hksearow":"⤥","hkswarow":"⤦","hoarr":"⇿","homtht":"∻","hookleftarrow":"↩","hookrightarrow":"↪","hopf":"𝕙","Hopf":"ℍ","horbar":"―","HorizontalLine":"─","hscr":"𝒽","Hscr":"ℋ","hslash":"ℏ","Hstrok":"Ħ","hstrok":"ħ","HumpDownHump":"≎","HumpEqual":"≏","hybull":"⁃","hyphen":"‐","Iacute":"Í","iacute":"í","ic":"⁣","Icirc":"Î","icirc":"î","Icy":"И","icy":"и","Idot":"İ","IEcy":"Е","iecy":"е","iexcl":"¡","iff":"⇔","ifr":"𝔦","Ifr":"ℑ","Igrave":"Ì","igrave":"ì","ii":"ⅈ","iiiint":"⨌","iiint":"∭","iinfin":"⧜","iiota":"℩","IJlig":"Ĳ","ijlig":"ĳ","Imacr":"Ī","imacr":"ī","image":"ℑ","ImaginaryI":"ⅈ","imagline":"ℐ","imagpart":"ℑ","imath":"ı","Im":"ℑ","imof":"⊷","imped":"Ƶ","Implies":"⇒","incare":"℅","in":"∈","infin":"∞","infintie":"⧝","inodot":"ı","intcal":"⊺","int":"∫","Int":"∬","integers":"ℤ","Integral":"∫","intercal":"⊺","Intersection":"⋂","intlarhk":"⨗","intprod":"⨼","InvisibleComma":"⁣","InvisibleTimes":"⁢","IOcy":"Ё","iocy":"ё","Iogon":"Į","iogon":"į","Iopf":"𝕀","iopf":"𝕚","Iota":"Ι","iota":"ι","iprod":"⨼","iquest":"¿","iscr":"𝒾","Iscr":"ℐ","isin":"∈","isindot":"⋵","isinE":"⋹","isins":"⋴","isinsv":"⋳","isinv":"∈","it":"⁢","Itilde":"Ĩ","itilde":"ĩ","Iukcy":"І","iukcy":"і","Iuml":"Ï","iuml":"ï","Jcirc":"Ĵ","jcirc":"ĵ","Jcy":"Й","jcy":"й","Jfr":"𝔍","jfr":"𝔧","jmath":"ȷ","Jopf":"𝕁","jopf":"𝕛","Jscr":"𝒥","jscr":"𝒿","Jsercy":"Ј","jsercy":"ј","Jukcy":"Є","jukcy":"є","Kappa":"Κ","kappa":"κ","kappav":"ϰ","Kcedil":"Ķ","kcedil":"ķ","Kcy":"К","kcy":"к","Kfr":"𝔎","kfr":"𝔨","kgreen":"ĸ","KHcy":"Х","khcy":"х","KJcy":"Ќ","kjcy":"ќ","Kopf":"𝕂","kopf":"𝕜","Kscr":"𝒦","kscr":"𝓀","lAarr":"⇚","Lacute":"Ĺ","lacute":"ĺ","laemptyv":"⦴","lagran":"ℒ","Lambda":"Λ","lambda":"λ","lang":"⟨","Lang":"⟪","langd":"⦑","langle":"⟨","lap":"⪅","Laplacetrf":"ℒ","laquo":"«","larrb":"⇤","larrbfs":"⤟","larr":"←","Larr":"↞","lArr":"⇐","larrfs":"⤝","larrhk":"↩","larrlp":"↫","larrpl":"⤹","larrsim":"⥳","larrtl":"↢","latail":"⤙","lAtail":"⤛","lat":"⪫","late":"⪭","lates":"⪭︀","lbarr":"⤌","lBarr":"⤎","lbbrk":"❲","lbrace":"{","lbrack":"[","lbrke":"⦋","lbrksld":"⦏","lbrkslu":"⦍","Lcaron":"Ľ","lcaron":"ľ","Lcedil":"Ļ","lcedil":"ļ","lceil":"⌈","lcub":"{","Lcy":"Л","lcy":"л","ldca":"⤶","ldquo":"“","ldquor":"„","ldrdhar":"⥧","ldrushar":"⥋","ldsh":"↲","le":"≤","lE":"≦","LeftAngleBracket":"⟨","LeftArrowBar":"⇤","leftarrow":"←","LeftArrow":"←","Leftarrow":"⇐","LeftArrowRightArrow":"⇆","leftarrowtail":"↢","LeftCeiling":"⌈","LeftDoubleBracket":"⟦","LeftDownTeeVector":"⥡","LeftDownVectorBar":"⥙","LeftDownVector":"⇃","LeftFloor":"⌊","leftharpoondown":"↽","leftharpoonup":"↼","leftleftarrows":"⇇","leftrightarrow":"↔","LeftRightArrow":"↔","Leftrightarrow":"⇔","leftrightarrows":"⇆","leftrightharpoons":"⇋","leftrightsquigarrow":"↭","LeftRightVector":"⥎","LeftTeeArrow":"↤","LeftTee":"⊣","LeftTeeVector":"⥚","leftthreetimes":"⋋","LeftTriangleBar":"⧏","LeftTriangle":"⊲","LeftTriangleEqual":"⊴","LeftUpDownVector":"⥑","LeftUpTeeVector":"⥠","LeftUpVectorBar":"⥘","LeftUpVector":"↿","LeftVectorBar":"⥒","LeftVector":"↼","lEg":"⪋","leg":"⋚","leq":"≤","leqq":"≦","leqslant":"⩽","lescc":"⪨","les":"⩽","lesdot":"⩿","lesdoto":"⪁","lesdotor":"⪃","lesg":"⋚︀","lesges":"⪓","lessapprox":"⪅","lessdot":"⋖","lesseqgtr":"⋚","lesseqqgtr":"⪋","LessEqualGreater":"⋚","LessFullEqual":"≦","LessGreater":"≶","lessgtr":"≶","LessLess":"⪡","lesssim":"≲","LessSlantEqual":"⩽","LessTilde":"≲","lfisht":"⥼","lfloor":"⌊","Lfr":"𝔏","lfr":"𝔩","lg":"≶","lgE":"⪑","lHar":"⥢","lhard":"↽","lharu":"↼","lharul":"⥪","lhblk":"▄","LJcy":"Љ","ljcy":"љ","llarr":"⇇","ll":"≪","Ll":"⋘","llcorner":"⌞","Lleftarrow":"⇚","llhard":"⥫","lltri":"◺","Lmidot":"Ŀ","lmidot":"ŀ","lmoustache":"⎰","lmoust":"⎰","lnap":"⪉","lnapprox":"⪉","lne":"⪇","lnE":"≨","lneq":"⪇","lneqq":"≨","lnsim":"⋦","loang":"⟬","loarr":"⇽","lobrk":"⟦","longleftarrow":"⟵","LongLeftArrow":"⟵","Longleftarrow":"⟸","longleftrightarrow":"⟷","LongLeftRightArrow":"⟷","Longleftrightarrow":"⟺","longmapsto":"⟼","longrightarrow":"⟶","LongRightArrow":"⟶","Longrightarrow":"⟹","looparrowleft":"↫","looparrowright":"↬","lopar":"⦅","Lopf":"𝕃","lopf":"𝕝","loplus":"⨭","lotimes":"⨴","lowast":"∗","lowbar":"_","LowerLeftArrow":"↙","LowerRightArrow":"↘","loz":"◊","lozenge":"◊","lozf":"⧫","lpar":"(","lparlt":"⦓","lrarr":"⇆","lrcorner":"⌟","lrhar":"⇋","lrhard":"⥭","lrm":"‎","lrtri":"⊿","lsaquo":"‹","lscr":"𝓁","Lscr":"ℒ","lsh":"↰","Lsh":"↰","lsim":"≲","lsime":"⪍","lsimg":"⪏","lsqb":"[","lsquo":"‘","lsquor":"‚","Lstrok":"Ł","lstrok":"ł","ltcc":"⪦","ltcir":"⩹","lt":"<","LT":"<","Lt":"≪","ltdot":"⋖","lthree":"⋋","ltimes":"⋉","ltlarr":"⥶","ltquest":"⩻","ltri":"◃","ltrie":"⊴","ltrif":"◂","ltrPar":"⦖","lurdshar":"⥊","luruhar":"⥦","lvertneqq":"≨︀","lvnE":"≨︀","macr":"¯","male":"♂","malt":"✠","maltese":"✠","Map":"⤅","map":"↦","mapsto":"↦","mapstodown":"↧","mapstoleft":"↤","mapstoup":"↥","marker":"▮","mcomma":"⨩","Mcy":"М","mcy":"м","mdash":"—","mDDot":"∺","measuredangle":"∡","MediumSpace":" ","Mellintrf":"ℳ","Mfr":"𝔐","mfr":"𝔪","mho":"℧","micro":"µ","midast":"*","midcir":"⫰","mid":"∣","middot":"·","minusb":"⊟","minus":"−","minusd":"∸","minusdu":"⨪","MinusPlus":"∓","mlcp":"⫛","mldr":"…","mnplus":"∓","models":"⊧","Mopf":"𝕄","mopf":"𝕞","mp":"∓","mscr":"𝓂","Mscr":"ℳ","mstpos":"∾","Mu":"Μ","mu":"μ","multimap":"⊸","mumap":"⊸","nabla":"∇","Nacute":"Ń","nacute":"ń","nang":"∠⃒","nap":"≉","napE":"⩰̸","napid":"≋̸","napos":"ŉ","napprox":"≉","natural":"♮","naturals":"ℕ","natur":"♮","nbsp":" ","nbump":"≎̸","nbumpe":"≏̸","ncap":"⩃","Ncaron":"Ň","ncaron":"ň","Ncedil":"Ņ","ncedil":"ņ","ncong":"≇","ncongdot":"⩭̸","ncup":"⩂","Ncy":"Н","ncy":"н","ndash":"–","nearhk":"⤤","nearr":"↗","neArr":"⇗","nearrow":"↗","ne":"≠","nedot":"≐̸","NegativeMediumSpace":"​","NegativeThickSpace":"​","NegativeThinSpace":"​","NegativeVeryThinSpace":"​","nequiv":"≢","nesear":"⤨","nesim":"≂̸","NestedGreaterGreater":"≫","NestedLessLess":"≪","NewLine":"\n","nexist":"∄","nexists":"∄","Nfr":"𝔑","nfr":"𝔫","ngE":"≧̸","nge":"≱","ngeq":"≱","ngeqq":"≧̸","ngeqslant":"⩾̸","nges":"⩾̸","nGg":"⋙̸","ngsim":"≵","nGt":"≫⃒","ngt":"≯","ngtr":"≯","nGtv":"≫̸","nharr":"↮","nhArr":"⇎","nhpar":"⫲","ni":"∋","nis":"⋼","nisd":"⋺","niv":"∋","NJcy":"Њ","njcy":"њ","nlarr":"↚","nlArr":"⇍","nldr":"‥","nlE":"≦̸","nle":"≰","nleftarrow":"↚","nLeftarrow":"⇍","nleftrightarrow":"↮","nLeftrightarrow":"⇎","nleq":"≰","nleqq":"≦̸","nleqslant":"⩽̸","nles":"⩽̸","nless":"≮","nLl":"⋘̸","nlsim":"≴","nLt":"≪⃒","nlt":"≮","nltri":"⋪","nltrie":"⋬","nLtv":"≪̸","nmid":"∤","NoBreak":"⁠","NonBreakingSpace":" ","nopf":"𝕟","Nopf":"ℕ","Not":"⫬","not":"¬","NotCongruent":"≢","NotCupCap":"≭","NotDoubleVerticalBar":"∦","NotElement":"∉","NotEqual":"≠","NotEqualTilde":"≂̸","NotExists":"∄","NotGreater":"≯","NotGreaterEqual":"≱","NotGreaterFullEqual":"≧̸","NotGreaterGreater":"≫̸","NotGreaterLess":"≹","NotGreaterSlantEqual":"⩾̸","NotGreaterTilde":"≵","NotHumpDownHump":"≎̸","NotHumpEqual":"≏̸","notin":"∉","notindot":"⋵̸","notinE":"⋹̸","notinva":"∉","notinvb":"⋷","notinvc":"⋶","NotLeftTriangleBar":"⧏̸","NotLeftTriangle":"⋪","NotLeftTriangleEqual":"⋬","NotLess":"≮","NotLessEqual":"≰","NotLessGreater":"≸","NotLessLess":"≪̸","NotLessSlantEqual":"⩽̸","NotLessTilde":"≴","NotNestedGreaterGreater":"⪢̸","NotNestedLessLess":"⪡̸","notni":"∌","notniva":"∌","notnivb":"⋾","notnivc":"⋽","NotPrecedes":"⊀","NotPrecedesEqual":"⪯̸","NotPrecedesSlantEqual":"⋠","NotReverseElement":"∌","NotRightTriangleBar":"⧐̸","NotRightTriangle":"⋫","NotRightTriangleEqual":"⋭","NotSquareSubset":"⊏̸","NotSquareSubsetEqual":"⋢","NotSquareSuperset":"⊐̸","NotSquareSupersetEqual":"⋣","NotSubset":"⊂⃒","NotSubsetEqual":"⊈","NotSucceeds":"⊁","NotSucceedsEqual":"⪰̸","NotSucceedsSlantEqual":"⋡","NotSucceedsTilde":"≿̸","NotSuperset":"⊃⃒","NotSupersetEqual":"⊉","NotTilde":"≁","NotTildeEqual":"≄","NotTildeFullEqual":"≇","NotTildeTilde":"≉","NotVerticalBar":"∤","nparallel":"∦","npar":"∦","nparsl":"⫽⃥","npart":"∂̸","npolint":"⨔","npr":"⊀","nprcue":"⋠","nprec":"⊀","npreceq":"⪯̸","npre":"⪯̸","nrarrc":"⤳̸","nrarr":"↛","nrArr":"⇏","nrarrw":"↝̸","nrightarrow":"↛","nRightarrow":"⇏","nrtri":"⋫","nrtrie":"⋭","nsc":"⊁","nsccue":"⋡","nsce":"⪰̸","Nscr":"𝒩","nscr":"𝓃","nshortmid":"∤","nshortparallel":"∦","nsim":"≁","nsime":"≄","nsimeq":"≄","nsmid":"∤","nspar":"∦","nsqsube":"⋢","nsqsupe":"⋣","nsub":"⊄","nsubE":"⫅̸","nsube":"⊈","nsubset":"⊂⃒","nsubseteq":"⊈","nsubseteqq":"⫅̸","nsucc":"⊁","nsucceq":"⪰̸","nsup":"⊅","nsupE":"⫆̸","nsupe":"⊉","nsupset":"⊃⃒","nsupseteq":"⊉","nsupseteqq":"⫆̸","ntgl":"≹","Ntilde":"Ñ","ntilde":"ñ","ntlg":"≸","ntriangleleft":"⋪","ntrianglelefteq":"⋬","ntriangleright":"⋫","ntrianglerighteq":"⋭","Nu":"Ν","nu":"ν","num":"#","numero":"№","numsp":" ","nvap":"≍⃒","nvdash":"⊬","nvDash":"⊭","nVdash":"⊮","nVDash":"⊯","nvge":"≥⃒","nvgt":">⃒","nvHarr":"⤄","nvinfin":"⧞","nvlArr":"⤂","nvle":"≤⃒","nvlt":"<⃒","nvltrie":"⊴⃒","nvrArr":"⤃","nvrtrie":"⊵⃒","nvsim":"∼⃒","nwarhk":"⤣","nwarr":"↖","nwArr":"⇖","nwarrow":"↖","nwnear":"⤧","Oacute":"Ó","oacute":"ó","oast":"⊛","Ocirc":"Ô","ocirc":"ô","ocir":"⊚","Ocy":"О","ocy":"о","odash":"⊝","Odblac":"Ő","odblac":"ő","odiv":"⨸","odot":"⊙","odsold":"⦼","OElig":"Œ","oelig":"œ","ofcir":"⦿","Ofr":"𝔒","ofr":"𝔬","ogon":"˛","Ograve":"Ò","ograve":"ò","ogt":"⧁","ohbar":"⦵","ohm":"Ω","oint":"∮","olarr":"↺","olcir":"⦾","olcross":"⦻","oline":"‾","olt":"⧀","Omacr":"Ō","omacr":"ō","Omega":"Ω","omega":"ω","Omicron":"Ο","omicron":"ο","omid":"⦶","ominus":"⊖","Oopf":"𝕆","oopf":"𝕠","opar":"⦷","OpenCurlyDoubleQuote":"“","OpenCurlyQuote":"‘","operp":"⦹","oplus":"⊕","orarr":"↻","Or":"⩔","or":"∨","ord":"⩝","order":"ℴ","orderof":"ℴ","ordf":"ª","ordm":"º","origof":"⊶","oror":"⩖","orslope":"⩗","orv":"⩛","oS":"Ⓢ","Oscr":"𝒪","oscr":"ℴ","Oslash":"Ø","oslash":"ø","osol":"⊘","Otilde":"Õ","otilde":"õ","otimesas":"⨶","Otimes":"⨷","otimes":"⊗","Ouml":"Ö","ouml":"ö","ovbar":"⌽","OverBar":"‾","OverBrace":"⏞","OverBracket":"⎴","OverParenthesis":"⏜","para":"¶","parallel":"∥","par":"∥","parsim":"⫳","parsl":"⫽","part":"∂","PartialD":"∂","Pcy":"П","pcy":"п","percnt":"%","period":".","permil":"‰","perp":"⊥","pertenk":"‱","Pfr":"𝔓","pfr":"𝔭","Phi":"Φ","phi":"φ","phiv":"ϕ","phmmat":"ℳ","phone":"☎","Pi":"Π","pi":"π","pitchfork":"⋔","piv":"ϖ","planck":"ℏ","planckh":"ℎ","plankv":"ℏ","plusacir":"⨣","plusb":"⊞","pluscir":"⨢","plus":"+","plusdo":"∔","plusdu":"⨥","pluse":"⩲","PlusMinus":"±","plusmn":"±","plussim":"⨦","plustwo":"⨧","pm":"±","Poincareplane":"ℌ","pointint":"⨕","popf":"𝕡","Popf":"ℙ","pound":"£","prap":"⪷","Pr":"⪻","pr":"≺","prcue":"≼","precapprox":"⪷","prec":"≺","preccurlyeq":"≼","Precedes":"≺","PrecedesEqual":"⪯","PrecedesSlantEqual":"≼","PrecedesTilde":"≾","preceq":"⪯","precnapprox":"⪹","precneqq":"⪵","precnsim":"⋨","pre":"⪯","prE":"⪳","precsim":"≾","prime":"′","Prime":"″","primes":"ℙ","prnap":"⪹","prnE":"⪵","prnsim":"⋨","prod":"∏","Product":"∏","profalar":"⌮","profline":"⌒","profsurf":"⌓","prop":"∝","Proportional":"∝","Proportion":"∷","propto":"∝","prsim":"≾","prurel":"⊰","Pscr":"𝒫","pscr":"𝓅","Psi":"Ψ","psi":"ψ","puncsp":" ","Qfr":"𝔔","qfr":"𝔮","qint":"⨌","qopf":"𝕢","Qopf":"ℚ","qprime":"⁗","Qscr":"𝒬","qscr":"𝓆","quaternions":"ℍ","quatint":"⨖","quest":"?","questeq":"≟","quot":"\"","QUOT":"\"","rAarr":"⇛","race":"∽̱","Racute":"Ŕ","racute":"ŕ","radic":"√","raemptyv":"⦳","rang":"⟩","Rang":"⟫","rangd":"⦒","range":"⦥","rangle":"⟩","raquo":"»","rarrap":"⥵","rarrb":"⇥","rarrbfs":"⤠","rarrc":"⤳","rarr":"→","Rarr":"↠","rArr":"⇒","rarrfs":"⤞","rarrhk":"↪","rarrlp":"↬","rarrpl":"⥅","rarrsim":"⥴","Rarrtl":"⤖","rarrtl":"↣","rarrw":"↝","ratail":"⤚","rAtail":"⤜","ratio":"∶","rationals":"ℚ","rbarr":"⤍","rBarr":"⤏","RBarr":"⤐","rbbrk":"❳","rbrace":"}","rbrack":"]","rbrke":"⦌","rbrksld":"⦎","rbrkslu":"⦐","Rcaron":"Ř","rcaron":"ř","Rcedil":"Ŗ","rcedil":"ŗ","rceil":"⌉","rcub":"}","Rcy":"Р","rcy":"р","rdca":"⤷","rdldhar":"⥩","rdquo":"”","rdquor":"”","rdsh":"↳","real":"ℜ","realine":"ℛ","realpart":"ℜ","reals":"ℝ","Re":"ℜ","rect":"▭","reg":"®","REG":"®","ReverseElement":"∋","ReverseEquilibrium":"⇋","ReverseUpEquilibrium":"⥯","rfisht":"⥽","rfloor":"⌋","rfr":"𝔯","Rfr":"ℜ","rHar":"⥤","rhard":"⇁","rharu":"⇀","rharul":"⥬","Rho":"Ρ","rho":"ρ","rhov":"ϱ","RightAngleBracket":"⟩","RightArrowBar":"⇥","rightarrow":"→","RightArrow":"→","Rightarrow":"⇒","RightArrowLeftArrow":"⇄","rightarrowtail":"↣","RightCeiling":"⌉","RightDoubleBracket":"⟧","RightDownTeeVector":"⥝","RightDownVectorBar":"⥕","RightDownVector":"⇂","RightFloor":"⌋","rightharpoondown":"⇁","rightharpoonup":"⇀","rightleftarrows":"⇄","rightleftharpoons":"⇌","rightrightarrows":"⇉","rightsquigarrow":"↝","RightTeeArrow":"↦","RightTee":"⊢","RightTeeVector":"⥛","rightthreetimes":"⋌","RightTriangleBar":"⧐","RightTriangle":"⊳","RightTriangleEqual":"⊵","RightUpDownVector":"⥏","RightUpTeeVector":"⥜","RightUpVectorBar":"⥔","RightUpVector":"↾","RightVectorBar":"⥓","RightVector":"⇀","ring":"˚","risingdotseq":"≓","rlarr":"⇄","rlhar":"⇌","rlm":"‏","rmoustache":"⎱","rmoust":"⎱","rnmid":"⫮","roang":"⟭","roarr":"⇾","robrk":"⟧","ropar":"⦆","ropf":"𝕣","Ropf":"ℝ","roplus":"⨮","rotimes":"⨵","RoundImplies":"⥰","rpar":")","rpargt":"⦔","rppolint":"⨒","rrarr":"⇉","Rrightarrow":"⇛","rsaquo":"›","rscr":"𝓇","Rscr":"ℛ","rsh":"↱","Rsh":"↱","rsqb":"]","rsquo":"’","rsquor":"’","rthree":"⋌","rtimes":"⋊","rtri":"▹","rtrie":"⊵","rtrif":"▸","rtriltri":"⧎","RuleDelayed":"⧴","ruluhar":"⥨","rx":"℞","Sacute":"Ś","sacute":"ś","sbquo":"‚","scap":"⪸","Scaron":"Š","scaron":"š","Sc":"⪼","sc":"≻","sccue":"≽","sce":"⪰","scE":"⪴","Scedil":"Ş","scedil":"ş","Scirc":"Ŝ","scirc":"ŝ","scnap":"⪺","scnE":"⪶","scnsim":"⋩","scpolint":"⨓","scsim":"≿","Scy":"С","scy":"с","sdotb":"⊡","sdot":"⋅","sdote":"⩦","searhk":"⤥","searr":"↘","seArr":"⇘","searrow":"↘","sect":"§","semi":";","seswar":"⤩","setminus":"∖","setmn":"∖","sext":"✶","Sfr":"𝔖","sfr":"𝔰","sfrown":"⌢","sharp":"♯","SHCHcy":"Щ","shchcy":"щ","SHcy":"Ш","shcy":"ш","ShortDownArrow":"↓","ShortLeftArrow":"←","shortmid":"∣","shortparallel":"∥","ShortRightArrow":"→","ShortUpArrow":"↑","shy":"­","Sigma":"Σ","sigma":"σ","sigmaf":"ς","sigmav":"ς","sim":"∼","simdot":"⩪","sime":"≃","simeq":"≃","simg":"⪞","simgE":"⪠","siml":"⪝","simlE":"⪟","simne":"≆","simplus":"⨤","simrarr":"⥲","slarr":"←","SmallCircle":"∘","smallsetminus":"∖","smashp":"⨳","smeparsl":"⧤","smid":"∣","smile":"⌣","smt":"⪪","smte":"⪬","smtes":"⪬︀","SOFTcy":"Ь","softcy":"ь","solbar":"⌿","solb":"⧄","sol":"/","Sopf":"𝕊","sopf":"𝕤","spades":"♠","spadesuit":"♠","spar":"∥","sqcap":"⊓","sqcaps":"⊓︀","sqcup":"⊔","sqcups":"⊔︀","Sqrt":"√","sqsub":"⊏","sqsube":"⊑","sqsubset":"⊏","sqsubseteq":"⊑","sqsup":"⊐","sqsupe":"⊒","sqsupset":"⊐","sqsupseteq":"⊒","square":"□","Square":"□","SquareIntersection":"⊓","SquareSubset":"⊏","SquareSubsetEqual":"⊑","SquareSuperset":"⊐","SquareSupersetEqual":"⊒","SquareUnion":"⊔","squarf":"▪","squ":"□","squf":"▪","srarr":"→","Sscr":"𝒮","sscr":"𝓈","ssetmn":"∖","ssmile":"⌣","sstarf":"⋆","Star":"⋆","star":"☆","starf":"★","straightepsilon":"ϵ","straightphi":"ϕ","strns":"¯","sub":"⊂","Sub":"⋐","subdot":"⪽","subE":"⫅","sube":"⊆","subedot":"⫃","submult":"⫁","subnE":"⫋","subne":"⊊","subplus":"⪿","subrarr":"⥹","subset":"⊂","Subset":"⋐","subseteq":"⊆","subseteqq":"⫅","SubsetEqual":"⊆","subsetneq":"⊊","subsetneqq":"⫋","subsim":"⫇","subsub":"⫕","subsup":"⫓","succapprox":"⪸","succ":"≻","succcurlyeq":"≽","Succeeds":"≻","SucceedsEqual":"⪰","SucceedsSlantEqual":"≽","SucceedsTilde":"≿","succeq":"⪰","succnapprox":"⪺","succneqq":"⪶","succnsim":"⋩","succsim":"≿","SuchThat":"∋","sum":"∑","Sum":"∑","sung":"♪","sup1":"¹","sup2":"²","sup3":"³","sup":"⊃","Sup":"⋑","supdot":"⪾","supdsub":"⫘","supE":"⫆","supe":"⊇","supedot":"⫄","Superset":"⊃","SupersetEqual":"⊇","suphsol":"⟉","suphsub":"⫗","suplarr":"⥻","supmult":"⫂","supnE":"⫌","supne":"⊋","supplus":"⫀","supset":"⊃","Supset":"⋑","supseteq":"⊇","supseteqq":"⫆","supsetneq":"⊋","supsetneqq":"⫌","supsim":"⫈","supsub":"⫔","supsup":"⫖","swarhk":"⤦","swarr":"↙","swArr":"⇙","swarrow":"↙","swnwar":"⤪","szlig":"ß","Tab":"\t","target":"⌖","Tau":"Τ","tau":"τ","tbrk":"⎴","Tcaron":"Ť","tcaron":"ť","Tcedil":"Ţ","tcedil":"ţ","Tcy":"Т","tcy":"т","tdot":"⃛","telrec":"⌕","Tfr":"𝔗","tfr":"𝔱","there4":"∴","therefore":"∴","Therefore":"∴","Theta":"Θ","theta":"θ","thetasym":"ϑ","thetav":"ϑ","thickapprox":"≈","thicksim":"∼","ThickSpace":"  ","ThinSpace":" ","thinsp":" ","thkap":"≈","thksim":"∼","THORN":"Þ","thorn":"þ","tilde":"˜","Tilde":"∼","TildeEqual":"≃","TildeFullEqual":"≅","TildeTilde":"≈","timesbar":"⨱","timesb":"⊠","times":"×","timesd":"⨰","tint":"∭","toea":"⤨","topbot":"⌶","topcir":"⫱","top":"⊤","Topf":"𝕋","topf":"𝕥","topfork":"⫚","tosa":"⤩","tprime":"‴","trade":"™","TRADE":"™","triangle":"▵","triangledown":"▿","triangleleft":"◃","trianglelefteq":"⊴","triangleq":"≜","triangleright":"▹","trianglerighteq":"⊵","tridot":"◬","trie":"≜","triminus":"⨺","TripleDot":"⃛","triplus":"⨹","trisb":"⧍","tritime":"⨻","trpezium":"⏢","Tscr":"𝒯","tscr":"𝓉","TScy":"Ц","tscy":"ц","TSHcy":"Ћ","tshcy":"ћ","Tstrok":"Ŧ","tstrok":"ŧ","twixt":"≬","twoheadleftarrow":"↞","twoheadrightarrow":"↠","Uacute":"Ú","uacute":"ú","uarr":"↑","Uarr":"↟","uArr":"⇑","Uarrocir":"⥉","Ubrcy":"Ў","ubrcy":"ў","Ubreve":"Ŭ","ubreve":"ŭ","Ucirc":"Û","ucirc":"û","Ucy":"У","ucy":"у","udarr":"⇅","Udblac":"Ű","udblac":"ű","udhar":"⥮","ufisht":"⥾","Ufr":"𝔘","ufr":"𝔲","Ugrave":"Ù","ugrave":"ù","uHar":"⥣","uharl":"↿","uharr":"↾","uhblk":"▀","ulcorn":"⌜","ulcorner":"⌜","ulcrop":"⌏","ultri":"◸","Umacr":"Ū","umacr":"ū","uml":"¨","UnderBar":"_","UnderBrace":"⏟","UnderBracket":"⎵","UnderParenthesis":"⏝","Union":"⋃","UnionPlus":"⊎","Uogon":"Ų","uogon":"ų","Uopf":"𝕌","uopf":"𝕦","UpArrowBar":"⤒","uparrow":"↑","UpArrow":"↑","Uparrow":"⇑","UpArrowDownArrow":"⇅","updownarrow":"↕","UpDownArrow":"↕","Updownarrow":"⇕","UpEquilibrium":"⥮","upharpoonleft":"↿","upharpoonright":"↾","uplus":"⊎","UpperLeftArrow":"↖","UpperRightArrow":"↗","upsi":"υ","Upsi":"ϒ","upsih":"ϒ","Upsilon":"Υ","upsilon":"υ","UpTeeArrow":"↥","UpTee":"⊥","upuparrows":"⇈","urcorn":"⌝","urcorner":"⌝","urcrop":"⌎","Uring":"Ů","uring":"ů","urtri":"◹","Uscr":"𝒰","uscr":"𝓊","utdot":"⋰","Utilde":"Ũ","utilde":"ũ","utri":"▵","utrif":"▴","uuarr":"⇈","Uuml":"Ü","uuml":"ü","uwangle":"⦧","vangrt":"⦜","varepsilon":"ϵ","varkappa":"ϰ","varnothing":"∅","varphi":"ϕ","varpi":"ϖ","varpropto":"∝","varr":"↕","vArr":"⇕","varrho":"ϱ","varsigma":"ς","varsubsetneq":"⊊︀","varsubsetneqq":"⫋︀","varsupsetneq":"⊋︀","varsupsetneqq":"⫌︀","vartheta":"ϑ","vartriangleleft":"⊲","vartriangleright":"⊳","vBar":"⫨","Vbar":"⫫","vBarv":"⫩","Vcy":"В","vcy":"в","vdash":"⊢","vDash":"⊨","Vdash":"⊩","VDash":"⊫","Vdashl":"⫦","veebar":"⊻","vee":"∨","Vee":"⋁","veeeq":"≚","vellip":"⋮","verbar":"|","Verbar":"‖","vert":"|","Vert":"‖","VerticalBar":"∣","VerticalLine":"|","VerticalSeparator":"❘","VerticalTilde":"≀","VeryThinSpace":" ","Vfr":"𝔙","vfr":"𝔳","vltri":"⊲","vnsub":"⊂⃒","vnsup":"⊃⃒","Vopf":"𝕍","vopf":"𝕧","vprop":"∝","vrtri":"⊳","Vscr":"𝒱","vscr":"𝓋","vsubnE":"⫋︀","vsubne":"⊊︀","vsupnE":"⫌︀","vsupne":"⊋︀","Vvdash":"⊪","vzigzag":"⦚","Wcirc":"Ŵ","wcirc":"ŵ","wedbar":"⩟","wedge":"∧","Wedge":"⋀","wedgeq":"≙","weierp":"℘","Wfr":"𝔚","wfr":"𝔴","Wopf":"𝕎","wopf":"𝕨","wp":"℘","wr":"≀","wreath":"≀","Wscr":"𝒲","wscr":"𝓌","xcap":"⋂","xcirc":"◯","xcup":"⋃","xdtri":"▽","Xfr":"𝔛","xfr":"𝔵","xharr":"⟷","xhArr":"⟺","Xi":"Ξ","xi":"ξ","xlarr":"⟵","xlArr":"⟸","xmap":"⟼","xnis":"⋻","xodot":"⨀","Xopf":"𝕏","xopf":"𝕩","xoplus":"⨁","xotime":"⨂","xrarr":"⟶","xrArr":"⟹","Xscr":"𝒳","xscr":"𝓍","xsqcup":"⨆","xuplus":"⨄","xutri":"△","xvee":"⋁","xwedge":"⋀","Yacute":"Ý","yacute":"ý","YAcy":"Я","yacy":"я","Ycirc":"Ŷ","ycirc":"ŷ","Ycy":"Ы","ycy":"ы","yen":"¥","Yfr":"𝔜","yfr":"𝔶","YIcy":"Ї","yicy":"ї","Yopf":"𝕐","yopf":"𝕪","Yscr":"𝒴","yscr":"𝓎","YUcy":"Ю","yucy":"ю","yuml":"ÿ","Yuml":"Ÿ","Zacute":"Ź","zacute":"ź","Zcaron":"Ž","zcaron":"ž","Zcy":"З","zcy":"з","Zdot":"Ż","zdot":"ż","zeetrf":"ℨ","ZeroWidthSpace":"​","Zeta":"Ζ","zeta":"ζ","zfr":"𝔷","Zfr":"ℨ","ZHcy":"Ж","zhcy":"ж","zigrarr":"⇝","zopf":"𝕫","Zopf":"ℤ","Zscr":"𝒵","zscr":"𝓏","zwj":"‍","zwnj":"‌"}

/***/ }),

/***/ 277:
/***/ (function(module, exports) {

module.exports = {"amp":"&","apos":"'","gt":">","lt":"<","quot":"\""}

/***/ }),

/***/ 278:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 279:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 280:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 281:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 282:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 336:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(698)
}
var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(393),
  /* template */
  __webpack_require__(922),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-42c61eca",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 337:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(697)
}
var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(397),
  /* template */
  __webpack_require__(921),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-4210beb0",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 343:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(885);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(412);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_bus__ = __webpack_require__(881);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_bus___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_bus__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_js_cookie__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_js_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_js_cookie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios__ = __webpack_require__(365);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_lazyload__ = __webpack_require__(882);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_lazyload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_lazyload__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__node_modules_basscss_basic_index_css__ = __webpack_require__(677);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__node_modules_basscss_basic_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__node_modules_basscss_basic_index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__node_modules_basscss_css_basscss_css__ = __webpack_require__(678);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__node_modules_basscss_css_basscss_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__node_modules_basscss_css_basscss_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_animate_css__ = __webpack_require__(676);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_animate_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_animate_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_babel_polyfill__ = __webpack_require__(219);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_babel_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_babel_polyfill__);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.






__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_vue_bus___default.a);


__WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.$axios = __WEBPACK_IMPORTED_MODULE_5_axios___default.a;


__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_6_vue_lazyload___default.a);







__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.productionTip = false;
__WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].beforeEach(function (to, from, next) {
    var name = __WEBPACK_IMPORTED_MODULE_4_js_cookie__["get"]("fb_name");
    if (name) {
        var userInfoInput = window.localStorage.getItem(name);
        if (to.name === "userInfoInput" && userInfoInput) {
            next({ path: "/" });
        } else if (to.name !== "userInfoInput" && !userInfoInput) {
            next({ path: "/userInfoInput" });
            return;
        }
    }
    if (to.name === "publishNews" || to.name === "userInfoInput") {
        if (!name) {
            next({ path: "/" });
            return;
        }
    }
    next();
});

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
    el: '#app',
    router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
    template: '<App/>',
    components: {
        App: __WEBPACK_IMPORTED_MODULE_1__App___default.a
    }
});

/***/ }),

/***/ 383:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'swiper-slide',
  data: function data() {
    return {
      slideClass: 'swiper-slide'
    };
  },
  ready: function ready() {
    this.update();
  },
  mounted: function mounted() {
    this.update();
    if (this.$parent.options.slideClass) {
      this.slideClass = this.$parent.options.slideClass;
    }
  },
  updated: function updated() {
    this.update();
  },
  attached: function attached() {
    this.update();
  },
  methods: {
    update: function update() {
      if (this.$parent && this.$parent.swiper && this.$parent.swiper.update) {
        this.$parent.swiper.update(true);
        if (this.$parent.options.loop) {
          this.$parent.swiper.reLoop();
        }
      }
    }
  }
});

/***/ }),

/***/ 384:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//

var browser = typeof window !== 'undefined';
if (browser) window.Swiper = __webpack_require__(334);
/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'swiper',
  props: {
    options: {
      type: Object,
      default: function _default() {
        return {
          autoplay: 3500
        };
      }
    },
    notNextTick: {
      type: Boolean,
      default: function _default() {
        return false;
      }
    }
  },
  data: function data() {
    return {
      defaultSwiperClasses: {
        wrapperClass: 'swiper-wrapper'
      }
    };
  },
  ready: function ready() {
    if (!this.swiper && browser) {
      this.swiper = new Swiper(this.$el, this.options);
    }
  },
  mounted: function mounted() {
    var self = this;
    var mount = function () {
      if (!self.swiper && browser) {
        delete self.options.notNextTick;
        var setClassName = false;
        for (var className in self.defaultSwiperClasses) {
          if (self.defaultSwiperClasses.hasOwnProperty(className)) {
            if (self.options[className]) {
              setClassName = true;
              self.defaultSwiperClasses[className] = self.options[className];
            }
          }
        }
        var mountInstance = function mountInstance() {
          self.swiper = new Swiper(self.$el, self.options);
        };
        setClassName ? self.$nextTick(mountInstance) : mountInstance();
      }
    }(this.options.notNextTick || this.notNextTick) ? mount() : this.$nextTick(mount);
  },
  updated: function updated() {
    if (this.swiper) {
      this.swiper.update();
    }
  },
  beforeDestroy: function beforeDestroy() {
    if (this.swiper) {
      this.swiper.destroy();
      delete this.swiper;
    }
  }
});

/***/ }),

/***/ 385:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_element_ui_lib_theme_default_dialog_css__ = __webpack_require__(681);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_element_ui_lib_theme_default_dialog_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_element_ui_lib_theme_default_dialog_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_default_base_css__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_default_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_default_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_dialog__ = __webpack_require__(655);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_dialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_dialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Header__ = __webpack_require__(893);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Header___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_Header__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Footer__ = __webpack_require__(892);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Footer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_Footer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_loginPanel__ = __webpack_require__(411);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_loginPanel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_loginPanel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_js_cookie__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_js_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_js_cookie__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




__WEBPACK_IMPORTED_MODULE_3_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_dialog___default.a);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app',
  data: function data() {
    return {
      dialogTableVisible: false,

      cids: [],
      loginSys: {
        isLogin: __WEBPACK_IMPORTED_MODULE_7_js_cookie__["get"]("fb_name") ? true : false,
        stat: '',
        loading: false
      },
      userInfo: {
        name: __WEBPACK_IMPORTED_MODULE_7_js_cookie__["get"]('fb_name') ? __WEBPACK_IMPORTED_MODULE_7_js_cookie__["get"]('fb_name') : '',
        account: '',
        password: ''
      }
    };
  },

  watch: {
    loginSys: {
      deep: true,
      handler: function handler(val, oldVal) {}
    }
  },
  created: function created() {
    var _this = this;

    this.$bus.on('getCids', function (cids) {
      return _this.cids = cids;
    });
    this.$bus.on('getLoginStat', function (stat) {
      _this.loginSys.stat = stat;
      _this.dialogTableVisible = stat.length > 0;
    });
    this.$bus.on('getUserInfo', function (info) {
      _this.userInfo.name = info.name;
      _this.userInfo.account = info.account;

      _this.loginSys.isLogin = true;
    });
    this.$bus.on('logout', function (stat) {
      if (stat === true) {
        _this.userInfo.anme = '';
        _this.userInfo.account = '';

        _this.loginSys.isLogin = false;
      } else {
        _this.loginSys.isLogin = true;
      }
    });
  },

  methods: {
    dialogLoginClose: function dialogLoginClose() {
      this.loginSys.stat = '';
    }
  },
  components: {
    pageHeader: __WEBPACK_IMPORTED_MODULE_4__components_Header___default.a,
    pageFooter: __WEBPACK_IMPORTED_MODULE_5__components_Footer___default.a,
    login: __WEBPACK_IMPORTED_MODULE_6__components_loginPanel__["login"],
    signup: __WEBPACK_IMPORTED_MODULE_6__components_loginPanel__["signup"],
    signupSuccess: __WEBPACK_IMPORTED_MODULE_6__components_loginPanel__["signupSuccess"]
  }
});

/***/ }),

/***/ 386:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_cookie__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_js_cookie__);
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'activedetail',
  data: function data() {
    return {
      times: '',
      ticketid: ''
    };
  },

  methods: {
    goHome: function goHome() {
      this.$router.push("/");
    },
    jumpActive: function jumpActive() {
      this.$router.push({ path: "/introduction" });
    }
  },
  mounted: function mounted() {
    this.times = __WEBPACK_IMPORTED_MODULE_0_js_cookie__["get"]('cur_issue') || 'xxxx';
    this.ticketid = __WEBPACK_IMPORTED_MODULE_0_js_cookie__["get"]('cur_ticketid') || 'xxxxxxx';
  }
});

/***/ }),

/***/ 387:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  mounted: function mounted() {
    var ad1 = document.createElement('script');
    var ad2 = document.createElement('script');

    ad1.setAttribute('src', '//cdn.adtrue.com/rtb/async.js');
    ad1.setAttribute('async', 'async');
    ad1.setAttribute('data-cfasync', 'false');
    ad2.innerHTML = '\n      var adtrue_tags = window.adtrue_tags || [];\n        adtrue_tags.push({\n            tag_id: 11562,\n            width: 300,\n            height: 250\n        });\n    ';

    var $target = this.$refs.adTrue;

    if ($target) {
      $target.appendChild(ad1);
      $target.appendChild(ad2);
    }
  }
});

/***/ }),

/***/ 388:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  mounted: function mounted() {
    // window.admicroAD.unit.push(function() { window.admicroAD.show('admzone492509')});

    // let ads = document.createElement('script')
    // ads.setAttribute('async', 'async')
    // ads.setAttribute('src',"//media1.admicro.vn/ads_codes/ads_box_492509.ads")
    // this.$refs.ads.appendChild(ads)
  }
});

/***/ }),

/***/ 389:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_forEach__ = __webpack_require__(207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_forEach___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_forEach__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_cids__ = __webpack_require__(226);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_utils_transformImgLink__ = __webpack_require__(65);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['data', 'keys', 'cids'],
  methods: {
    shift: function shift(link) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__assets_utils_transformImgLink__["a" /* default */])(link);
    },
    formatUtc: function formatUtc(utc) {
      return __WEBPACK_IMPORTED_MODULE_0_moment___default.a.unix(utc).fromNow();
    }
  },
  computed: {
    cidsObj: function cidsObj() {
      var cidsObj = {};
      __WEBPACK_IMPORTED_MODULE_1_lodash_forEach___default()(__WEBPACK_IMPORTED_MODULE_2__assets_cids__["a" /* default */], function (val) {
        cidsObj[val['cid']] = val['label'];
      });
      return cidsObj;
    }
  }
});

/***/ }),

/***/ 390:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_utils_transformImgLink__ = __webpack_require__(65);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['data'],
  methods: {
    shift: function shift(link) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__assets_utils_transformImgLink__["a" /* default */])(link);
    },
    formatUtc: function formatUtc(utc) {
      return __WEBPACK_IMPORTED_MODULE_0_moment___default.a.unix(utc).fromNow();
    }
  }
});

/***/ }),

/***/ 391:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({});

/***/ }),

/***/ 392:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'footer',
  methods: {
    handleClick: function handleClick() {
      this.$router.push('/want');
    }
  },
  data: function data() {
    return {};
  }
});

/***/ }),

/***/ 393:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'GameRule',
  methods: {
    jumpIphone: function jumpIphone() {
      this.$router.push({ path: '/introduction' });
    },
    jumpWinner: function jumpWinner() {
      this.$router.push({ path: '/winner' });
    }
  }
});

/***/ }),

/***/ 394:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_element_ui_lib_theme_default_message_box_css__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_element_ui_lib_theme_default_message_box_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_element_ui_lib_theme_default_message_box_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_message_box__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_message_box___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_message_box__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(416);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_default_button_css__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_default_button_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_default_button_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_default_base_css__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_default_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_default_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_button__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_locale_lang_th__ = __webpack_require__(179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_locale_lang_th___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_locale_lang_th__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_locale__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_locale___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_locale__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Register__ = __webpack_require__(337);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Register___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_Register__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_js_cookie__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_js_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_js_cookie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_moment__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_moment__);






//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_locale___default.a.use(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_locale_lang_th___default.a);

__WEBPACK_IMPORTED_MODULE_6_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_button___default.a);


__WEBPACK_IMPORTED_MODULE_11_moment___default.a.locale("th");

/* harmony default export */ __webpack_exports__["default"] = ({
  name: "header",
  props: ["cids", "isLogin", "userName"],
  data: function data() {
    return {
      curDate: __WEBPACK_IMPORTED_MODULE_11_moment___default()().format("dddd, D/M/YYYY"),
      navList: []
    };
  },

  watch: {
    cids: function cids() {
      this.navList = [].concat(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(this.cids));
    }
  },
  methods: {
    publish: function publish() {
      this.$router.push({ path: "/publishNews" });
    },
    handleFB: function handleFB() {
      var that = this;
      FB.getLoginStatus(function (response) {
        if (response.status === "connected") {
          FB.api('/me', function (res) {
            var name = res.name;

            that.$bus.emit("getUserInfo", { name: name, account: '' });
            that.$bus.emit("logout", false);
            __WEBPACK_IMPORTED_MODULE_10_js_cookie__["set"]("fb_name", name, { path: "" });
            var hasInputUserInfo = window.localStorage.getItem(name);
            if (hasInputUserInfo) {
              that.$router.push({ path: "/" });
            } else {
              that.$router.push({ path: "/userInfoInput" });
            }
          });
        } else {
          FB.login(function (_ref) {
            var status = _ref.status,
                authResponse = _ref.authResponse;

            if (status === "connected") {
              FB.api('/me', function (res) {
                var name = res.name;

                that.$bus.emit("getUserInfo", { name: name, account: '' });
                that.$bus.emit("logout", false);
                __WEBPACK_IMPORTED_MODULE_10_js_cookie__["set"]("fb_name", name, { path: "" });
                var hasInputUserInfo = window.localStorage.getItem(name);
                if (hasInputUserInfo) {
                  that.$router.push({ path: "/" });
                } else {
                  that.$router.push({ path: "/userInfoInput" });
                }
              });
              __WEBPACK_IMPORTED_MODULE_10_js_cookie__["set"]("access_token", authResponse.accessToken, {
                path: ""
              });
              __WEBPACK_IMPORTED_MODULE_10_js_cookie__["set"]("fid", authResponse.userID, { path: "" });
              that.$router.push({ path: "/" });
            } else {
              alert("login filed!");
            }
          }, { scope: "public_profile,email" });
        }
      });
    },
    handleLoginButton: function handleLoginButton(stat) {
      this.$bus.emit("getLoginStat", stat);
    },
    handleLogout: function handleLogout() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_message_box___default.a.confirm("Nhấn lần nữa để thoát ứng dụng!", "Thông báo", {
        type: "warning"
      }).then(function () {
        FB.logout();
        __WEBPACK_IMPORTED_MODULE_10_js_cookie__["set"]("fb_name", "", { path: "" });
        __WEBPACK_IMPORTED_MODULE_10_js_cookie__["set"]("access_token", "", {
          path: ""
        });
        __WEBPACK_IMPORTED_MODULE_10_js_cookie__["set"]("fid", "", { path: "" });
        _this.$bus.emit("logout", true);
      }).catch(function () {});
    },
    gotoWinRecord: function gotoWinRecord() {
      this.$router.push({ path: '/winrecord' });
    }
  },
  components: {
    Register: __WEBPACK_IMPORTED_MODULE_9__components_Register___default.a
  }
});

/***/ }),

/***/ 395:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_element_ui_lib_theme_default_message_box_css__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_element_ui_lib_theme_default_message_box_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_element_ui_lib_theme_default_message_box_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_default_base_css__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_default_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_default_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_message_box__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_message_box___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_message_box__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_locale_lang_th__ = __webpack_require__(179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_locale_lang_th___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_locale_lang_th__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_locale__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_locale___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_locale__);




 //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_locale___default.a.use(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_locale_lang_th___default.a);

/* harmony default export */ __webpack_exports__["default"] = ({
  name: "introduction",
  mounted: function mounted() {
    __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_message_box___default.a.alert('Nhằm đem đến trải nghiệm tốt nhất cho người dùng, hệ thống xin thông báo, chương trình "Mỗi tuần 01 xe máy" sẽ tạm ngưng hoạt động vào ngày 02/07/2019. Chương trình mới sẽ mở sớm nhất có thể. Cảm ơn sự ủng hộ của các bạn trong thời gian qua.', "Thông báo", {
      dangerouslyUseHTMLString: true,
      center: true
    });
  }
});

/***/ }),

/***/ 396:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue2_editor__ = __webpack_require__(938);
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      title: "",
      content: ""
    };
  },

  components: { VueEditor: __WEBPACK_IMPORTED_MODULE_0_vue2_editor__["a" /* VueEditor */] },
  methods: {
    onSubmit: function onSubmit() {
      var that = this;
      if (this.title == "") {
        this.$message({ message: "title is empty", type: 'error' });
        return;
      }
      if (this.content == "") {
        this.$message({ message: "the news content is empty", type: 'error' });
        return;
      }
      this.$alert('Bài viết đã được gửi và sẽ được duyệt trong vòng 24h', 'Gửi bài thành công', {
        confirmButtonText: 'OK',
        callback: function callback() {
          that.$router.push({ path: "/" });
        }
      });
    }
  }
});

/***/ }),

/***/ 397:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(227);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_default_message_box_css__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_default_message_box_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_default_message_box_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_default_base_css__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_default_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_default_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_message_box__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_message_box___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_message_box__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_js_cookie__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_js_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_js_cookie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_loading_overlay__ = __webpack_require__(338);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_loading_overlay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_loading_overlay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_loading_overlay_dist_vue_loading_css__ = __webpack_require__(282);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_loading_overlay_dist_vue_loading_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_loading_overlay_dist_vue_loading_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_locale_lang_th__ = __webpack_require__(179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_locale_lang_th___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_locale_lang_th__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_locale__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_locale___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_locale__);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



// Import component

// Import stylesheet



__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_locale___default.a.use(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_locale_lang_th___default.a);

/* harmony default export */ __webpack_exports__["default"] = ({
  name: "Register",
  data: function data() {
    return {
      name: '',
      cardid: "",
      cellphone: '',
      email: "",
      isLoading: false,
      fullPage: true
    };
  },

  components: {
    Loading: __WEBPACK_IMPORTED_MODULE_5_vue_loading_overlay___default.a
  },
  mounted: function mounted() {
    __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_message_box___default.a.alert('Nhằm đem đến trải nghiệm tốt nhất cho người dùng, hệ thống xin thông báo, chương trình "Mỗi tuần 01 xe máy" sẽ tạm ngưng hoạt động vào ngày 02/07/2019. Chương trình mới sẽ mở sớm nhất có thể. Cảm ơn sự ủng hộ của các bạn trong thời gian qua.', "Thông báo", {
      dangerouslyUseHTMLString: true,
      center: true
    });
  },

  methods: {
    submitInfo: function submitInfo(e) {
      return;
      var that = this;
      this.isLoading = true;
      e.preventDefault();
      var userInfo = {
        name: this.name,
        cardid: this.cardid,
        cellphone: this.cellphone,
        email: this.email,
        fid: __WEBPACK_IMPORTED_MODULE_4_js_cookie__["get"]('fid')
      };
      if (!userInfo.fid) {
        __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_message_box___default.a.alert('please login with facebook first !', 'Thông báo');
        this.isLoading = false;
        return;
      }
      var config = {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      };
      var xhr = new XMLHttpRequest();
      xhr.onreadystatechange = function () {
        if (xhr.status == 200 && xhr.readyState == 4) {
          var res = JSON.parse(xhr.response);
          that.isLoading = false;
          var lottery = res.lottery,
              errcode = res.errcode;

          if (errcode === 1) {
            __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_message_box___default.a.alert('Bạn đang tham gia chương trình tuần này, không thể lặp lại, xin đợi tới tuần sau', "Thông báo");
          } else {
            __WEBPACK_IMPORTED_MODULE_4_js_cookie__["set"]('cur_ticketid', lottery.lottery);
            __WEBPACK_IMPORTED_MODULE_4_js_cookie__["set"]('cur_issue', lottery.issue);
            __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_message_box___default.a.alert('Tham gia thành công!', 'Thông báo').then(function () {
              that.$router.push("/activedetail");
            });
          }
        }
      };
      xhr.open('post', '/submit');
      xhr.setRequestHeader('Content-Type', 'application/json');
      xhr.send(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(userInfo));
    },
    jumpActive: function jumpActive() {
      this.$router.push({ path: "/introduction" });
    },
    goHome: function goHome() {
      this.$router.push("/");
    }
  }
});

/***/ }),

/***/ 398:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_take__ = __webpack_require__(848);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_take___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_take__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get__ = __webpack_require__(208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rss_parser_browser__ = __webpack_require__(866);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rss_parser_browser___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_rss_parser_browser__);
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      articleList: []
    };
  },

  methods: {
    fetchFeed: function fetchFeed() {
      var _this = this;

      this.$axios.get('/rss-prnasia-1969.xml').then(function (response) {
        var data = response.data;

        __WEBPACK_IMPORTED_MODULE_2_rss_parser_browser___default.a.parseString(data, function (err, parsed) {
          if (!err) _this.articleList = __WEBPACK_IMPORTED_MODULE_0_lodash_take___default()(__WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(parsed, 'feed.entries', []), 8);
        });
      });
    }
  },
  mounted: function mounted() {
    this.fetchFeed();
  }
});

/***/ }),

/***/ 399:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assets_utils_transformImgLink__ = __webpack_require__(65);
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['data'],
  methods: {
    shift: function shift(link) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__assets_utils_transformImgLink__["a" /* default */])(link);
    }
  }
});

/***/ }),

/***/ 400:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_awesome_swiper__ = __webpack_require__(880);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_awesome_swiper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_awesome_swiper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_swiper_dist_css_swiper_css__ = __webpack_require__(281);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_swiper_dist_css_swiper_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__node_modules_swiper_dist_css_swiper_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_utils_transformImgLink__ = __webpack_require__(65);
//
//
//
//
//
//
//
//
//
//





__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_awesome_swiper___default.a);


/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['data'],
  data: function data() {
    return {
      swiperOpt: {
        pagination: '.swiper-pagination',
        nextButton: '.swiper-button-next',
        prevButton: '.swiper-button-prev',
        autoplay: 3000,
        // autoplayDisableOnInteraction: false,
        initialSlide: 1,
        paginationClickable: true,
        spaceBetween: 30,
        loop: true
      }
    };
  },

  methods: {
    shift: function shift(link) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__assets_utils_transformImgLink__["a" /* default */])(link);
    }
  }
});

/***/ }),

/***/ 401:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_element_ui_lib_theme_default_message_css__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_element_ui_lib_theme_default_message_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_element_ui_lib_theme_default_message_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_message__ = __webpack_require__(180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_message___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_message__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_default_message_box_css__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_default_message_box_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_default_message_box_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_message_box__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_message_box___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_message_box__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_default_checkbox_css__ = __webpack_require__(679);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_default_checkbox_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_default_checkbox_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_checkbox__ = __webpack_require__(653);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_checkbox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_checkbox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_default_upload_css__ = __webpack_require__(684);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_default_upload_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_default_upload_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_upload__ = __webpack_require__(663);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_upload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_upload__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_default_date_picker_css__ = __webpack_require__(680);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_default_date_picker_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_default_date_picker_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_date_picker__ = __webpack_require__(654);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_date_picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_element_ui_lib_date_picker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_theme_default_radio_group_css__ = __webpack_require__(682);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_theme_default_radio_group_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_element_ui_lib_theme_default_radio_group_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_radio_group__ = __webpack_require__(660);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_radio_group___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_element_ui_lib_radio_group__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_element_ui_lib_theme_default_radio_css__ = __webpack_require__(683);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_element_ui_lib_theme_default_radio_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_element_ui_lib_theme_default_radio_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_element_ui_lib_theme_default_base_css__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_element_ui_lib_theme_default_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_element_ui_lib_theme_default_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_element_ui_lib_radio__ = __webpack_require__(661);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_element_ui_lib_radio___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_element_ui_lib_radio__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_js_cookie__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_js_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_js_cookie__);















//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




__WEBPACK_IMPORTED_MODULE_15_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_14_element_ui_lib_radio___default.a);
__WEBPACK_IMPORTED_MODULE_15_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_11_element_ui_lib_radio_group___default.a);
__WEBPACK_IMPORTED_MODULE_15_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_9_element_ui_lib_date_picker___default.a);
__WEBPACK_IMPORTED_MODULE_15_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_upload___default.a);
__WEBPACK_IMPORTED_MODULE_15_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_checkbox___default.a);
__WEBPACK_IMPORTED_MODULE_15_vue__["default"].prototype.$alert = __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_message_box___default.a.alert;
__WEBPACK_IMPORTED_MODULE_15_vue__["default"].prototype.$message = __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_message___default.a;
/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            form: {
                name: __WEBPACK_IMPORTED_MODULE_16_js_cookie__["get"]("fb_name"),
                checked: false,
                sex: "Nam",
                adress: "",
                idno: '',
                date: '',
                idnoFrom: "",
                idnoDate: "",
                email: "",
                phone: '',
                fileList: []
            }
        };
    },

    methods: {
        handleChange: function handleChange(file) {
            this.form.fileList.push(file);
        },
        handleRemove: function handleRemove() {
            this.form.fileList = [];
        },
        onSubmit: function onSubmit() {
            var that = this;
            if (this.form.idno == "" || this.form.email == '') {
                this.$message({ message: "Số CMND/CCCD and Email must input ", type: 'error' });
                return;
            }
            if (!/^\d+$/.test(this.form.idno)) {
                this.$message({ message: "Số CMND/CCCD is error", type: 'error' });
                return;
            }
            if (!/^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/.test(this.form.email)) {
                this.$message({ message: "Email address is error", type: 'error' });
                return;
            }
            if (!this.form.checked) {
                this.$message({ message: "Vui lòng đọc Thỏa Thuận Cung Cấp và Sử Dụng Dịch Vụ của Báo Hay 24h", type: 'error' });
                return;
            }
            var name = __WEBPACK_IMPORTED_MODULE_16_js_cookie__["get"]("fb_name");
            window.localStorage.setItem(name, '1');
            this.$alert('Thông tin bạn nhập đã được bảo lưu thành công', 'Thông tin cập nhật thành công', {
                confirmButtonText: 'OK',
                callback: function callback() {
                    that.$router.push({ path: "/" });
                }
            });
        }
    }
});

/***/ }),

/***/ 402:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(227);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_js_cookie__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_js_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_js_cookie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_loading_overlay__ = __webpack_require__(338);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_loading_overlay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_loading_overlay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_loading_overlay_dist_vue_loading_css__ = __webpack_require__(282);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_loading_overlay_dist_vue_loading_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_loading_overlay_dist_vue_loading_css__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


// Import component

// Import stylesheet


/* harmony default export */ __webpack_exports__["default"] = ({
  name: "winrecord",
  data: function data() {
    return {
      ticket: '',
      winStatus: 0,
      message: '',
      times: '',
      ticketid: '',
      isLoading: false,
      fullPage: true
    };
  },

  components: {
    Loading: __WEBPACK_IMPORTED_MODULE_2_vue_loading_overlay___default.a
  },
  mounted: function mounted() {
    var that = this;
    this.isLoading = true;
    this.times = __WEBPACK_IMPORTED_MODULE_1_js_cookie__["get"]('cur_issue') || 'xxxx';
    this.ticketid = __WEBPACK_IMPORTED_MODULE_1_js_cookie__["get"]('cur_ticketid') || 'xxxxxxx';
    var fid = __WEBPACK_IMPORTED_MODULE_1_js_cookie__["get"]('fid');
    var xhr = new XMLHttpRequest();
    xhr.onreadystatechange = function () {
      if (xhr.status == 200 && xhr.readyState == 4) {
        that.isLoading = false;
        var res = JSON.parse(xhr.response);
        if (res.errcode === 0) {
          var lotterys = res.lotterys,
              status = res.status,
              message = res.message;

          that.ticket = lotterys;
          that.winStatus = status;
          that.message = message;
        } else {
          that.ticket = null;
        }
      }
    };
    xhr.open('post', '/query');
    xhr.setRequestHeader('Content-Type', 'application/json');
    xhr.send(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({ fid: fid }));
  }
});

/***/ }),

/***/ 403:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_element_ui_lib_theme_default_message_css__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_element_ui_lib_theme_default_message_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_element_ui_lib_theme_default_message_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_message__ = __webpack_require__(180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_message___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_message__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(415);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_default_input_css__ = __webpack_require__(280);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_default_input_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_default_input_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_input__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_default_button_css__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_default_button_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_default_button_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_button__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_default_form_item_css__ = __webpack_require__(278);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_default_form_item_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_default_form_item_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_form_item__ = __webpack_require__(272);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_form_item___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_form_item__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_default_form_css__ = __webpack_require__(279);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_default_form_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_default_form_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_theme_default_base_css__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_theme_default_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_element_ui_lib_theme_default_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_form__ = __webpack_require__(273);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_element_ui_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_q__ = __webpack_require__(326);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_q___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_q__);












//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





__WEBPACK_IMPORTED_MODULE_12_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_11_element_ui_lib_form___default.a);
__WEBPACK_IMPORTED_MODULE_12_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_form_item___default.a);
__WEBPACK_IMPORTED_MODULE_12_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_button___default.a);
__WEBPACK_IMPORTED_MODULE_12_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_input___default.a);

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'login',
  data: function data() {
    return {
      loading: false,
      userInfo: {
        account: '',
        password: ''
      },
      userInfoRules: {
        account: [{ required: true, message: 'Nhập tên đăng nhập', trigger: 'blur' }, { min: 5, message: 'Tên đăng nhập giới hạn từ 5-20 ký tự', trigger: 'blur' }],
        password: [{ required: true, message: 'Nhập mật khẩu', trigger: 'blur' }, { min: 5, max: 20, message: 'Mật khẩu giới hạn từ 5-20 ký tự', trigger: 'blur' }]
      }
    };
  },

  methods: {
    handleLoginButton: function handleLoginButton(stat) {
      this.$bus.emit('getLoginStat', stat);
    },
    handleLogin: function handleLogin() {
      var _this = this;

      this.loading = true;
      __WEBPACK_IMPORTED_MODULE_13_q___default.a.fcall(this.validateForm).then(this.ajaxLogin).catch(function (err) {
        console.log(err);
        _this.loading = false;
      });
    },
    validateForm: function validateForm() {
      var formName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'userInfo';

      this.$refs[formName].validate(function (valid) {
        if (!valid) {
          throw new Error('validate Error');
        }
        return;
      });
    },
    ajaxLogin: function ajaxLogin() {
      var _this2 = this;

      this.$axios({
        url: '/vn/login',
        method: 'post',
        data: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, this.userInfo)
      }).then(function (res) {
        if (res.data.ret === 0) {
          _this2.$bus.emit('getLoginStat', '');
          _this2.$bus.emit('getUserInfo', _this2.userInfo);
        } else {
          throw new Error(res.data.msg);
        }
      }).catch(function (err) {
        _this2.loading = false;
        __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_message___default()({
          message: err.message,
          type: 'warning'
        });
      });
    }
  }
});

/***/ }),

/***/ 404:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_element_ui_lib_theme_default_message_css__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_element_ui_lib_theme_default_message_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_element_ui_lib_theme_default_message_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_message__ = __webpack_require__(180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_message___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_message__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_default_input_css__ = __webpack_require__(280);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_default_input_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_default_input_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_input__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_default_button_css__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_default_button_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_default_button_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_button__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_default_form_item_css__ = __webpack_require__(278);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_default_form_item_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_default_form_item_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_form_item__ = __webpack_require__(272);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_form_item___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_form_item__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_default_form_css__ = __webpack_require__(279);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_default_form_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_default_form_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_default_base_css__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_default_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_default_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_form__ = __webpack_require__(273);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_element_ui_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_q__ = __webpack_require__(326);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_q___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_q__);











//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





__WEBPACK_IMPORTED_MODULE_11_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_10_element_ui_lib_form___default.a);
__WEBPACK_IMPORTED_MODULE_11_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_form_item___default.a);
__WEBPACK_IMPORTED_MODULE_11_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_button___default.a);
__WEBPACK_IMPORTED_MODULE_11_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_input___default.a);

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'signup',
  data: function data() {
    var _this = this;

    var passwordRepeatRule = function passwordRepeatRule(rule, value, callback) {
      if (value === '') {
        callback(new Error('Vui lòng nhập lại mật khẩu'));
      } else if (value !== _this.userInfo.password) {
        callback(new Error('Mật khẩu không đúng'));
      } else {
        callback();
      }
    };
    return {
      loading: false,
      userInfo: {
        account: '',
        password: '',
        passwordRepeat: ''
      },
      userInfoRules: {
        account: [{ required: true, message: 'Nhập tên đăng nhập', trigger: 'blur' }, { min: 5, message: 'Tên đăng nhập giới hạn từ 5-20 ký tự', trigger: 'blur' }],
        password: [{ required: true, message: 'Nhập mật khẩu', trigger: 'blur' }, { min: 5, max: 20, message: 'Mật khẩu giới hạn từ 5-20 ký tự', trigger: 'blur' }],
        passwordRepeat: [{ required: true, message: 'Vui lòng nhập lại mật khẩu', trigger: 'blur' }, { validator: passwordRepeatRule, trigger: 'blur' }]
      }
    };
  },

  methods: {
    handleSignup: function handleSignup() {
      var _this2 = this;

      this.loading = true;
      __WEBPACK_IMPORTED_MODULE_12_q___default.a.fcall(this.validateForm).then(this.ajaxSignup).catch(function (err) {
        console.log(err);
        _this2.loading = false;
      });
    },
    validateForm: function validateForm() {
      var formName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'userInfo';

      this.$refs[formName].validate(function (valid) {
        if (!valid) {
          throw new Error('validate Error');
        }
        return;
      });
    },
    ajaxSignup: function ajaxSignup() {
      var _this3 = this;

      this.$axios({
        url: '/vn/register',
        method: 'post',
        data: function () {
          var _userInfo = _this3.userInfo,
              account = _userInfo.account,
              password = _userInfo.password;

          return { account: account, password: password };
        }()
      }).then(function (res) {
        if (res.data.ret === 0) {
          _this3.$bus.emit('getLoginStat', '');
          _this3.$bus.emit('getUserInfo', _this3.userInfo);

          __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_message___default()({
            message: 'Đăng ký thành công'
          });
        } else {
          throw new Error(res.data.msg);
        }
      }).catch(function (err) {
        _this3.loading = false;
        __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_message___default()({
          message: err.message,
          type: 'warning'
        });
      });
    }
  }
});

/***/ }),

/***/ 405:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_utils_transformImgLink__ = __webpack_require__(65);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['data'],
  methods: {
    shift: function shift(link) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__assets_utils_transformImgLink__["a" /* default */])(link);
    },
    formatUtc: function formatUtc(utc) {
      return __WEBPACK_IMPORTED_MODULE_0_moment___default.a.unix(utc).fromNow();
    }
  }
});

/***/ }),

/***/ 406:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_utils_transformImgLink__ = __webpack_require__(65);
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['data'],
  methods: {
    shift: function shift(link) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__assets_utils_transformImgLink__["a" /* default */])(link);
    },
    formatUtc: function formatUtc(utc) {
      return __WEBPACK_IMPORTED_MODULE_0_moment___default.a.unix(utc).fromNow();
    }
  }
});

/***/ }),

/***/ 407:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: "winner",
  data: function data() {
    return {
      list: [{ date: '1/07/2019', number: '934250', tel: '0364***009' }]
    };
  },
  mounted: function mounted() {
    this.$refs.winner.style.minHeight = 'calc(100vh - ' + (document.querySelector('header').offsetHeight + document.querySelector('footer').offsetHeight) + 'px)';
  }
});

/***/ }),

/***/ 408:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_get__ = __webpack_require__(208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_slice__ = __webpack_require__(322);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_slice___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_slice__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_forEach__ = __webpack_require__(207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_forEach___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_forEach__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_utils_arr2chunk__ = __webpack_require__(410);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_scrollreveal__ = __webpack_require__(868);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_Clamp_clamp__ = __webpack_require__(409);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_Clamp_clamp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__assets_Clamp_clamp__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Swiper__ = __webpack_require__(898);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Swiper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_Swiper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_cids__ = __webpack_require__(226);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_sideBottomList__ = __webpack_require__(904);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_sideBottomList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_sideBottomList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_sideRightList__ = __webpack_require__(905);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_sideRightList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_sideRightList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_ClassifyList__ = __webpack_require__(889);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_ClassifyList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_ClassifyList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_StickyList__ = __webpack_require__(897);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_StickyList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_StickyList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_DetailList__ = __webpack_require__(890);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_DetailList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_DetailList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_GameRule__ = __webpack_require__(336);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_GameRule___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__components_GameRule__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_Admzone__ = __webpack_require__(888);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_Admzone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__components_Admzone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_AdTrue__ = __webpack_require__(887);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_AdTrue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__components_AdTrue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_RssNews__ = __webpack_require__(896);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_RssNews___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__components_RssNews__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_Download__ = __webpack_require__(891);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_Download___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__components_Download__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__node_modules_swiper_dist_css_swiper_css__ = __webpack_require__(281);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__node_modules_swiper_dist_css_swiper_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__node_modules_swiper_dist_css_swiper_css__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







// TODO: 侧边固定功能
// import Sticky from 'stickybits'


















/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'home',
  data: function data() {
    return {
      cids: [],

      dataAll: {},
      dataSource: {},
      dataCarousel: {},
      dataSide: {},
      dataSideBottom: {},
      dataSticky: {},
      dataDetail: {},
      dataPrimary: {},
      dataPrimaryKeys: [],

      sr: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_scrollreveal__["a" /* default */])({
        reset: false,
        duration: 1200,
        distance: '20px'
      })
    };
  },

  watch: {
    dataSource: function dataSource() {
      this.dataCarousel = __WEBPACK_IMPORTED_MODULE_1_lodash_slice___default()(this.dataSource, 0, 3);
      this.dataSideBottom = __WEBPACK_IMPORTED_MODULE_1_lodash_slice___default()(this.dataSource, 3, 7);
      this.dataSide = __WEBPACK_IMPORTED_MODULE_1_lodash_slice___default()(this.dataSource, 7, 14);
      this.dataSticky = __WEBPACK_IMPORTED_MODULE_1_lodash_slice___default()(this.dataSource, 14, 21);

      // if (this.isHomePage) {
      //   this.dataPrimary = arr2chunk.chunkFromValue(this.dataAll)
      //   this.dataPrimaryKeys = arr2chunk.chunkFromKey(this.dataAll)
      //   this.dataDetail = []
      // } else {
      //   this.dataDetail = this.isHomePage ? [] : _slice(this.dataSource, 21, 31)
      //   this.dataPrimary = []
      // }
      this.dataDetail = __WEBPACK_IMPORTED_MODULE_1_lodash_slice___default()(this.dataSource, 21, 31);
    },
    $route: function $route() {
      this.getData();
    }
  },
  computed: {
    cid: function cid() {
      return __WEBPACK_IMPORTED_MODULE_0_lodash_get___default()(this, '$route.query.id') || 0;
    },
    isHomePage: function isHomePage() {
      return this.cid === 0;
    }
  },
  methods: {
    jumpGame: function jumpGame() {
      this.$router.push({ path: '/gameRule' });
    },
    switchData: function switchData() {
      var _this = this;

      if (this.$route.query.id) {
        // this.dataSource = this.dataAll[this.$route.query.id]
        this.dataSource = this.dataAll;
      } else {
        // this.dataSource = this.dataAll['0'] || this.dataAll[this.cid]
        this.dataSource = this.dataAll;
      }
      this.$nextTick(function () {
        _this.sr.reveal('.primary-list li');
      });
    },
    getData: function getData() {
      var _this2 = this;

      var API =  true ? 'https://web.thtopnews.com' : '';

      // let url = this.isHomePage ? '/homepage_data.json' : `/category_${this.$route.query.id}_data.json`
      var url = API + '/api/content/content_list';
      this.$axios.post(url, { category_id: this.$route.query.id || 2 }).then(function (res) {
        var data = res.data.data;

        _this2.dataAll = data;
      }).then(function () {
        _this2.switchData();

        _this2.$nextTick(function () {
          _this2.setClamp();

          // TODO: 侧边固定功能
          // Sticky(this.$el.querySelector('.sticky-list'))
        });
      }).catch(function (err) {
        _this2.$router.push('/');
        console.log(err);
      });
    },
    emitCids: function emitCids(cids) {
      this.cids = cids;
      this.$bus.emit('getCids', cids);
    },
    setClamp: function setClamp() {
      var clampList = this.$el.querySelectorAll('[data-clamp]');
      __WEBPACK_IMPORTED_MODULE_2_lodash_forEach___default()(clampList, function (el) {
        window.$clamp(el, { clamp: el.getAttribute('data-clamp') });
      });
    }
  },
  mounted: function mounted() {
    this.getData();
    this.emitCids(__WEBPACK_IMPORTED_MODULE_7__assets_cids__["a" /* default */]);
  },

  components: {
    swiper: __WEBPACK_IMPORTED_MODULE_6__components_Swiper___default.a,
    sideBottomList: __WEBPACK_IMPORTED_MODULE_8__components_sideBottomList___default.a,
    sideRightList: __WEBPACK_IMPORTED_MODULE_9__components_sideRightList___default.a,
    classifyList: __WEBPACK_IMPORTED_MODULE_10__components_ClassifyList___default.a,
    stickyList: __WEBPACK_IMPORTED_MODULE_11__components_StickyList___default.a,
    detailList: __WEBPACK_IMPORTED_MODULE_12__components_DetailList___default.a,
    gameRule: __WEBPACK_IMPORTED_MODULE_13__components_GameRule___default.a,
    admzone: __WEBPACK_IMPORTED_MODULE_14__components_Admzone___default.a,
    RssNews: __WEBPACK_IMPORTED_MODULE_16__components_RssNews___default.a,
    AdTrue: __WEBPACK_IMPORTED_MODULE_15__components_AdTrue___default.a,
    Download: __WEBPACK_IMPORTED_MODULE_17__components_Download___default.a
  }
});

/***/ }),

/***/ 409:
/***/ (function(module, exports) {

/*!
* Clamp.js 0.5.1
*
* Copyright 2011-2013, Joseph Schmitt http://joe.sh
* Released under the WTFPL license
* http://sam.zoy.org/wtfpl/
*/

(function () {
    /**
     * Clamps a text node.
     * @param {HTMLElement} element. Element containing the text node to clamp.
     * @param {Object} options. Options to pass to the clamper.
     */
    function clamp(element, options) {
        options = options || {};

        var self = this,
            win = window,
            opt = {
            clamp: options.clamp || 2,
            useNativeClamp: typeof options.useNativeClamp != 'undefined' ? options.useNativeClamp : true,
            splitOnChars: options.splitOnChars || ['.', '-', '–', '—', ' '], //Split on sentences (periods), hypens, en-dashes, em-dashes, and words (spaces).
            animate: options.animate || false,
            truncationChar: options.truncationChar || '…',
            truncationHTML: options.truncationHTML
        },
            sty = element.style,
            originalText = element.innerHTML,
            supportsNativeClamp = typeof element.style.webkitLineClamp != 'undefined',
            clampValue = opt.clamp,
            isCSSValue = clampValue.indexOf && (clampValue.indexOf('px') > -1 || clampValue.indexOf('em') > -1),
            truncationHTMLContainer;

        if (opt.truncationHTML) {
            truncationHTMLContainer = document.createElement('span');
            truncationHTMLContainer.innerHTML = opt.truncationHTML;
        }

        // UTILITY FUNCTIONS __________________________________________________________

        /**
         * Return the current style for an element.
         * @param {HTMLElement} elem The element to compute.
         * @param {string} prop The style property.
         * @returns {number}
         */
        function computeStyle(elem, prop) {
            if (!win.getComputedStyle) {
                win.getComputedStyle = function (el, pseudo) {
                    this.el = el;
                    this.getPropertyValue = function (prop) {
                        var re = /(\-([a-z]){1})/g;
                        if (prop == 'float') prop = 'styleFloat';
                        if (re.test(prop)) {
                            prop = prop.replace(re, function () {
                                return arguments[2].toUpperCase();
                            });
                        }
                        return el.currentStyle && el.currentStyle[prop] ? el.currentStyle[prop] : null;
                    };
                    return this;
                };
            }

            return win.getComputedStyle(elem, null).getPropertyValue(prop);
        }

        /**
         * Returns the maximum number of lines of text that should be rendered based
         * on the current height of the element and the line-height of the text.
         */
        function getMaxLines(height) {
            var availHeight = height || element.clientHeight,
                lineHeight = getLineHeight(element);

            return Math.max(Math.floor(availHeight / lineHeight), 0);
        }

        /**
         * Returns the maximum height a given element should have based on the line-
         * height of the text and the given clamp value.
         */
        function getMaxHeight(clmp) {
            var lineHeight = getLineHeight(element);
            return lineHeight * clmp;
        }

        /**
         * Returns the line-height of an element as an integer.
         */
        function getLineHeight(elem) {
            var lh = computeStyle(elem, 'line-height');
            if (lh == 'normal') {
                // Normal line heights vary from browser to browser. The spec recommends
                // a value between 1.0 and 1.2 of the font size. Using 1.1 to split the diff.
                lh = parseInt(computeStyle(elem, 'font-size')) * 1.2;
            }
            return parseInt(lh);
        }

        // MEAT AND POTATOES (MMMM, POTATOES...) ______________________________________
        var splitOnChars = opt.splitOnChars.slice(0),
            splitChar = splitOnChars[0],
            chunks,
            lastChunk;

        /**
         * Gets an element's last child. That may be another node or a node's contents.
         */
        function getLastChild(elem) {
            //Current element has children, need to go deeper and get last child as a text node
            if (elem.lastChild.children && elem.lastChild.children.length > 0) {
                return getLastChild(Array.prototype.slice.call(elem.children).pop());
            }
            //This is the absolute last child, a text node, but something's wrong with it. Remove it and keep trying
            else if (!elem.lastChild || !elem.lastChild.nodeValue || elem.lastChild.nodeValue == '' || elem.lastChild.nodeValue == opt.truncationChar) {
                    elem.lastChild.parentNode.removeChild(elem.lastChild);
                    return getLastChild(element);
                }
                //This is the last child we want, return it
                else {
                        return elem.lastChild;
                    }
        }

        /**
         * Removes one character at a time from the text until its width or
         * height is beneath the passed-in max param.
         */
        function truncate(target, maxHeight) {
            if (!maxHeight) {
                return;
            }

            /**
             * Resets global variables.
             */
            function reset() {
                splitOnChars = opt.splitOnChars.slice(0);
                splitChar = splitOnChars[0];
                chunks = null;
                lastChunk = null;
            }

            var nodeValue = target.nodeValue.replace(opt.truncationChar, '');

            //Grab the next chunks
            if (!chunks) {
                //If there are more characters to try, grab the next one
                if (splitOnChars.length > 0) {
                    splitChar = splitOnChars.shift();
                }
                //No characters to chunk by. Go character-by-character
                else {
                        splitChar = '';
                    }

                chunks = nodeValue.split(splitChar);
            }

            //If there are chunks left to remove, remove the last one and see if
            // the nodeValue fits.
            if (chunks.length > 1) {
                // console.log('chunks', chunks);
                lastChunk = chunks.pop();
                // console.log('lastChunk', lastChunk);
                applyEllipsis(target, chunks.join(splitChar));
            }
            //No more chunks can be removed using this character
            else {
                    chunks = null;
                }

            //Insert the custom HTML before the truncation character
            if (truncationHTMLContainer) {
                target.nodeValue = target.nodeValue.replace(opt.truncationChar, '');
                element.innerHTML = target.nodeValue + ' ' + truncationHTMLContainer.innerHTML + opt.truncationChar;
            }

            //Search produced valid chunks
            if (chunks) {
                //It fits
                if (element.clientHeight <= maxHeight) {
                    //There's still more characters to try splitting on, not quite done yet
                    if (splitOnChars.length >= 0 && splitChar != '') {
                        applyEllipsis(target, chunks.join(splitChar) + splitChar + lastChunk);
                        chunks = null;
                    }
                    //Finished!
                    else {
                            return element.innerHTML;
                        }
                }
            }
            //No valid chunks produced
            else {
                    //No valid chunks even when splitting by letter, time to move
                    //on to the next node
                    if (splitChar == '') {
                        applyEllipsis(target, '');
                        target = getLastChild(element);

                        reset();
                    }
                }

            //If you get here it means still too big, let's keep truncating
            if (opt.animate) {
                setTimeout(function () {
                    truncate(target, maxHeight);
                }, opt.animate === true ? 10 : opt.animate);
            } else {
                return truncate(target, maxHeight);
            }
        }

        function applyEllipsis(elem, str) {
            elem.nodeValue = str + opt.truncationChar;
        }

        // CONSTRUCTOR ________________________________________________________________

        if (clampValue == 'auto') {
            clampValue = getMaxLines();
        } else if (isCSSValue) {
            clampValue = getMaxLines(parseInt(clampValue));
        }

        var clampedText;
        if (supportsNativeClamp && opt.useNativeClamp) {
            sty.overflow = 'hidden';
            sty.textOverflow = 'ellipsis';
            sty.webkitBoxOrient = 'vertical';
            sty.display = '-webkit-box';
            sty.webkitLineClamp = clampValue;

            if (isCSSValue) {
                sty.height = opt.clamp + 'px';
            }
        } else {
            var height = getMaxHeight(clampValue);
            if (height <= element.clientHeight) {
                clampedText = truncate(getLastChild(element), height);
            }
        }

        return {
            'original': originalText,
            'clamped': clampedText
        };
    }

    window.$clamp = clamp;
})();

/***/ }),

/***/ 410:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_reduce__ = __webpack_require__(846);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_reduce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_reduce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_forEach__ = __webpack_require__(207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_forEach___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_forEach__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_fp_omit__ = __webpack_require__(830);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_fp_omit___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_fp_omit__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_fp_values__ = __webpack_require__(832);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_fp_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_fp_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_fp_keys__ = __webpack_require__(828);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_fp_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash_fp_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_fp_map__ = __webpack_require__(829);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_fp_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash_fp_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_fp_slice__ = __webpack_require__(831);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_fp_slice___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash_fp_slice__);








// 排除分类的id
var excludeCid = ['0'];
// 每个分类截取数量
var sliceEnd = 6;

function arr2chunk(arr) {
  var arr1 = [];
  var arr2 = [];
  var arr3 = [];
  __WEBPACK_IMPORTED_MODULE_1_lodash_forEach___default()(arr, function (val, idx) {
    switch (true) {
      case idx % 3 === 0:
        arr1.push(val);
        break;
      case idx % 3 === 1:
        arr2.push(val);
        break;
      case idx % 3 === 2:
        arr3.push(val);
        break;
    }
  });
  return [arr1, arr2, arr3];
}

var chunkFromValue = function chunkFromValue(data) {
  return __WEBPACK_IMPORTED_MODULE_0_lodash_reduce___default()([__WEBPACK_IMPORTED_MODULE_2_lodash_fp_omit___default()(excludeCid), __WEBPACK_IMPORTED_MODULE_3_lodash_fp_values___default.a, __WEBPACK_IMPORTED_MODULE_5_lodash_fp_map___default()(__WEBPACK_IMPORTED_MODULE_6_lodash_fp_slice___default()(0, sliceEnd)), arr2chunk], function (acc, fn) {
    return fn(acc);
  }, data);
};
var chunkFromKey = function chunkFromKey(data) {
  return __WEBPACK_IMPORTED_MODULE_0_lodash_reduce___default()([__WEBPACK_IMPORTED_MODULE_2_lodash_fp_omit___default()(excludeCid), __WEBPACK_IMPORTED_MODULE_4_lodash_fp_keys___default.a, arr2chunk], function (acc, fn) {
    return fn(acc);
  }, data);
};

/* unused harmony default export */ var _unused_webpack_default_export = ({
  chunkFromKey: chunkFromKey,
  chunkFromValue: chunkFromValue
});

/***/ }),

/***/ 411:
/***/ (function(module, exports, __webpack_require__) {

var req = __webpack_require__(948);

req.keys().forEach(function (key) {
  var componentName = key.replace(/^.+\/([^/]+)\.vue/, '$1');
  module.exports[componentName] = req(key);
});

/***/ }),

/***/ 412:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(936);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pages_Home__ = __webpack_require__(907);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pages_Home___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__pages_Home__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_GameRule__ = __webpack_require__(336);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_GameRule___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_GameRule__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Register__ = __webpack_require__(337);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Register___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_Register__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Introduction__ = __webpack_require__(894);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Introduction___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_Introduction__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_ActiveDetail__ = __webpack_require__(886);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_ActiveDetail___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_ActiveDetail__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_winner__ = __webpack_require__(906);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_winner___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_winner__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_WinRecord__ = __webpack_require__(900);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_WinRecord___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_WinRecord__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_UserInfoInput__ = __webpack_require__(899);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_UserInfoInput___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_UserInfoInput__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_PublishNews__ = __webpack_require__(895);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_PublishNews___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_PublishNews__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__pages_Want__ = __webpack_require__(908);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__pages_Want___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__pages_Want__);













__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({

  routes: [{
    path: '/',
    name: 'Home',
    component: __WEBPACK_IMPORTED_MODULE_2__pages_Home___default.a
  }, {
    path: '/want',
    name: 'Want',
    component: __WEBPACK_IMPORTED_MODULE_11__pages_Want___default.a
  }, {
    path: '/gameRule',
    name: 'gameRule',
    component: __WEBPACK_IMPORTED_MODULE_3__components_GameRule___default.a
  }, {
    path: '/register',
    name: 'register',
    component: __WEBPACK_IMPORTED_MODULE_4__components_Register___default.a
  }, {
    path: '/publishNews',
    name: 'publishNews',
    component: __WEBPACK_IMPORTED_MODULE_10__components_PublishNews___default.a
  }, {
    path: '/userInfoInput',
    name: 'userInfoInput',
    component: __WEBPACK_IMPORTED_MODULE_9__components_UserInfoInput___default.a
  }, {
    path: '/introduction',
    name: 'introduction',
    component: __WEBPACK_IMPORTED_MODULE_5__components_Introduction___default.a
  }, {
    path: '/winner',
    name: 'winner',
    component: __WEBPACK_IMPORTED_MODULE_7__components_winner___default.a
  }, {
    path: '/activedetail',
    name: 'activedetail',
    component: __WEBPACK_IMPORTED_MODULE_6__components_ActiveDetail___default.a
  }, {
    path: '/winrecord',
    name: 'winrecord',
    component: __WEBPACK_IMPORTED_MODULE_8__components_WinRecord___default.a
  }],
  scrollBehavior: function scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  }
}));

/***/ }),

/***/ 59:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 65:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var transformImgLink = function transformImgLink(link) {
  // return 'https://images.headlines.pw' + link
  return link;
};

/* harmony default export */ __webpack_exports__["a"] = (transformImgLink);

/***/ }),

/***/ 674:
/***/ (function(module, exports) {

module.exports = {"0":65533,"128":8364,"130":8218,"131":402,"132":8222,"133":8230,"134":8224,"135":8225,"136":710,"137":8240,"138":352,"139":8249,"140":338,"142":381,"145":8216,"146":8217,"147":8220,"148":8221,"149":8226,"150":8211,"151":8212,"152":732,"153":8482,"154":353,"155":8250,"156":339,"158":382,"159":376}

/***/ }),

/***/ 675:
/***/ (function(module, exports) {

module.exports = {"Aacute":"Á","aacute":"á","Acirc":"Â","acirc":"â","acute":"´","AElig":"Æ","aelig":"æ","Agrave":"À","agrave":"à","amp":"&","AMP":"&","Aring":"Å","aring":"å","Atilde":"Ã","atilde":"ã","Auml":"Ä","auml":"ä","brvbar":"¦","Ccedil":"Ç","ccedil":"ç","cedil":"¸","cent":"¢","copy":"©","COPY":"©","curren":"¤","deg":"°","divide":"÷","Eacute":"É","eacute":"é","Ecirc":"Ê","ecirc":"ê","Egrave":"È","egrave":"è","ETH":"Ð","eth":"ð","Euml":"Ë","euml":"ë","frac12":"½","frac14":"¼","frac34":"¾","gt":">","GT":">","Iacute":"Í","iacute":"í","Icirc":"Î","icirc":"î","iexcl":"¡","Igrave":"Ì","igrave":"ì","iquest":"¿","Iuml":"Ï","iuml":"ï","laquo":"«","lt":"<","LT":"<","macr":"¯","micro":"µ","middot":"·","nbsp":" ","not":"¬","Ntilde":"Ñ","ntilde":"ñ","Oacute":"Ó","oacute":"ó","Ocirc":"Ô","ocirc":"ô","Ograve":"Ò","ograve":"ò","ordf":"ª","ordm":"º","Oslash":"Ø","oslash":"ø","Otilde":"Õ","otilde":"õ","Ouml":"Ö","ouml":"ö","para":"¶","plusmn":"±","pound":"£","quot":"\"","QUOT":"\"","raquo":"»","reg":"®","REG":"®","sect":"§","shy":"­","sup1":"¹","sup2":"²","sup3":"³","szlig":"ß","THORN":"Þ","thorn":"þ","times":"×","Uacute":"Ú","uacute":"ú","Ucirc":"Û","ucirc":"û","Ugrave":"Ù","ugrave":"ù","uml":"¨","Uuml":"Ü","uuml":"ü","Yacute":"Ý","yacute":"ý","yen":"¥","yuml":"ÿ"}

/***/ }),

/***/ 676:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 677:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 678:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 679:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 680:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 681:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 682:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 683:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 684:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 685:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 686:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 687:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 688:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 689:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 690:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 691:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 692:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 693:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 694:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 695:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 696:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 697:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 698:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 699:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 700:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 701:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 702:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 703:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 704:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 705:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 706:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 707:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 708:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 709:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 710:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 854:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./th": 325,
	"./th.js": 325
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 854;

/***/ }),

/***/ 876:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/active2019.07eaffe.jpg";

/***/ }),

/***/ 877:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/introduction_banner.6fbcc3b.png";

/***/ }),

/***/ 883:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(383),
  /* template */
  __webpack_require__(934),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 884:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(384),
  /* template */
  __webpack_require__(911),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 885:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(694)
}
var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(385),
  /* template */
  __webpack_require__(918),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 886:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(702)
}
var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(386),
  /* template */
  __webpack_require__(927),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-587a6a84",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 887:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(700)
}
var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(387),
  /* template */
  __webpack_require__(925),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-570f22c4",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 888:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(388),
  /* template */
  __webpack_require__(923),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 889:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(710)
}
var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(389),
  /* template */
  __webpack_require__(935),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-d9ce7962",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 890:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(709)
}
var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(390),
  /* template */
  __webpack_require__(933),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-a9f50548",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 891:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(693)
}
var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(391),
  /* template */
  __webpack_require__(917),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-2c1443d6",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 892:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(695)
}
var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(392),
  /* template */
  __webpack_require__(919),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-3cce42e8",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 893:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(706)
}
var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(394),
  /* template */
  __webpack_require__(930),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-5e00a6da",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 894:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(691)
}
var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(395),
  /* template */
  __webpack_require__(915),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-2462d227",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 895:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(708)
}
var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(396),
  /* template */
  __webpack_require__(932),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-a3a651f6",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 896:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(690)
}
var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(398),
  /* template */
  __webpack_require__(914),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-1ab12ec8",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 897:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(692)
}
var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(399),
  /* template */
  __webpack_require__(916),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-25e57ef4",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 898:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(686)
  __webpack_require__(685)
}
var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(400),
  /* template */
  __webpack_require__(909),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-03cc7f45",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 899:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(701)
}
var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(401),
  /* template */
  __webpack_require__(926),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-57ed6474",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 900:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(688)
}
var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(402),
  /* template */
  __webpack_require__(912),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-0dade9e0",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 901:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(699)
}
var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(403),
  /* template */
  __webpack_require__(924),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 902:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(703)
}
var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(404),
  /* template */
  __webpack_require__(928),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 903:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(5)(
  /* script */
  null,
  /* template */
  null,
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 904:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(707)
}
var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(405),
  /* template */
  __webpack_require__(931),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-735c2866",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 905:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(689)
}
var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(406),
  /* template */
  __webpack_require__(913),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-1a29deb4",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 906:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(696)
}
var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(407),
  /* template */
  __webpack_require__(920),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-40088128",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 907:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(705)
  __webpack_require__(704)
}
var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(408),
  /* template */
  __webpack_require__(929),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-5c7ff3f4",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 908:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(687)
}
var Component = __webpack_require__(5)(
  /* script */
  null,
  /* template */
  __webpack_require__(910),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-05e2a2b7",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 909:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('swiper', {
    attrs: {
      "options": _vm.swiperOpt
    }
  }, [_vm._l((_vm.data), function(item) {
    return _c('swiper-slide', {
      key: item.id
    }, [_c('a', {
      attrs: {
        "href": item.origin_url,
        "target": "_blank"
      }
    }, [_c('h3', {
      staticClass: "swiper-title px3 center"
    }, [_vm._v(_vm._s(item.title))])]), _c('div', {
      staticClass: "swiper-img"
    }, [_c('img', {
      style: ({
        width: '100%',
        height: '100%'
      }),
      attrs: {
        "src": _vm.shift(item.o_pic_list[0])
      }
    })])])
  }), _c('div', {
    staticClass: "swiper-pagination",
    slot: "pagination"
  })], 2)
},staticRenderFns: []}

/***/ }),

/***/ 910:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h1', [_vm._v("\n    JOB TITLE: Biên Tập Viên – Chuyên mục Tử vi – 12 con giáp/Chòm sao\n  ")]), _vm._v(" "), _c('h3', [_vm._v("\n    MIÊU TẢ CÔNG VIỆC\n  ")]), _vm._v(" "), _c('p', [_vm._v("\n    Phụ trách tổng hợp thông tin, tin tức, cập nhật tin bài theo chủ đề: Chòm sao, Chiêm tinh, Tử vi..."), _c('br'), _vm._v("\n    Chịu trách nhiệm nội dung, lập kế hoạch phát triển nội dung và vận hành sản phẩm."), _c('br'), _vm._v("\n    Tham gia kế hoạch phát triển sản phẩm Trưởng nhóm nhằm tăng sức thu hút cho nội dung."), _c('br'), _vm._v("\n    Có khả năng quản lý vận hành trang mục tin."), _c('br'), _vm._v("\n    Các công việc khác theo sự phân công của cấp trên"), _c('br')]), _vm._v(" "), _c('h3', [_vm._v("\n    YÊU CẦU\n  ")]), _vm._v(" "), _c('p', [_vm._v("\n  Tuổi từ 25 tuổi, ưu tiên có kiến thức mảng chiêm tinh, chòm sao/con giáp, kinh nghiệm làm việc ở các trang báo điện tử: zing.vn, Yan new, Kênh 14, Báo mới, 24h, hoặc quản lý các Fanpage chuyên mục Tử vi, Chòm Sao, Chiêm tinh…"), _c('br'), _vm._v("\n  Tư duy đề tài nóng tốt, sáng tạo, bắt kịp xu hướng, cập nhật ý tưởng sáng tạo. "), _c('br'), _vm._v("\n  Sử dụng thành thạo phần mềm văn phòng, có khả năng viết lách và xử lý văn bản."), _c('br'), _vm._v("\n  Nhạy bén với cách sử dụng từ ngữ, phát hiện đề tài mới. "), _c('br'), _vm._v("\n  Ưu tiên biết sử dụng các phần mềm chỉnh sửa hình ảnh. "), _c('br'), _vm._v("\n  Chịu được áp lực công việc, tư duy logic rõ ràng. "), _c('br')]), _vm._v(" "), _c('h3', [_vm._v("\n    PHÚC LỢI\n  ")]), _vm._v(" "), _c('p', [_vm._v("\n  Trợ cấp tiền cơm trưa : 30,000 vnđ/ngày; trợ cấp gửi xe : 300,000 vnđ/tháng."), _c('br'), _vm._v("\n  Chế độ đãi ngộ bao gồm chi phí điện thoại, tiếp khách, hỗ trợ khác.(Tùy vị trí)"), _c('br'), _vm._v("\n  Chế độ chăm sóc y tế, bảo hiểm sức khỏe."), _c('br'), _vm._v("\n  Khám sức khỏe hàng năm, trà chiều hàng ngày"), _c('br'), _vm._v("\n  Đầy đủ chế độ bảo hiểm, Phúc Lợi theo quy định pháp luật."), _c('br'), _vm._v("\n  Tham gia các hoạt động, phong trào của Công Ty."), _c('br'), _vm._v("\n  Chính sách du lịch, nghỉ mát trong năm."), _c('br')]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h1', [_vm._v("\n    JOB TITLE: Biên Tập Viên (Tiếng Trung)\n  ")]), _vm._v(" "), _c('h3', [_vm._v("\n  MIÊU TẢ CÔNG VIỆC\n  ")]), _vm._v(" "), _c('p', [_vm._v("\n  Phụ trách biên tập, kiểm soát nội dung."), _c('br'), _vm._v("\n  Chịu trách nhiệm nội dung lập kế hoạch cho nội dung và lượng tương tác của độc giả."), _c('br'), _vm._v("\n  Hoạch định nội dung, xây dựng chiến lược nội dung cho trang tin."), _c('br'), _vm._v("\n  Tham gia đóng góp ý tưởng cùng Trưởng nhóm nhằm tăng sức thu hút cho nội dung."), _c('br'), _vm._v("\n  Có khả năng quản lý vận hành trang mục tin."), _c('br')]), _vm._v(" "), _c('h3', [_vm._v("\n    YÊU CẦU\n  ")]), _vm._v(" "), _c('p', [_vm._v("\n  Tuổi từ 22 tuổi, ưu tiên có kinh nghiệm làm việc ở các trang báo điện tử: zing.vn, Yan new, Kênh 14, Báo mới , 24h...."), _c('br'), _vm._v("\n  Thành thạo tiếng Trung (Nghe, nói, đọc, viết)."), _c('br'), _vm._v("\n  Tư duy đề tài nóng tốt, sáng tạo trong ý tưởng cho chủ mục yêu cầu. "), _c('br'), _vm._v("\n  Sử dụng thành thạo phần mềm văn phòng, có khả năng viết lách và xử lý văn bản."), _c('br'), _vm._v("\n  Nhạy bén với cách sử dụng từ ngữ, phát hiện đề tài mới. "), _c('br'), _vm._v("\n  Ưu tiên biết sử dụng các phần mềm chỉnh sửa hình ảnh. "), _c('br'), _vm._v("\n  Chịu được áp lực công việc, tư duy logic rõ ràng."), _c('br')]), _vm._v(" "), _c('h3', [_vm._v("\n  PHÚC LỢI\n  ")]), _vm._v(" "), _c('p', [_vm._v("\n  Trợ cấp tiền cơm trưa : 30,000 vnđ/ngày; trợ cấp gửi xe : 300,000 vnđ/tháng."), _c('br'), _vm._v("\n  Chế độ đãi ngộ bao gồm chi phí điện thoại, tiếp khách, hỗ trợ khác.(Tùy vị trí)"), _c('br'), _vm._v("\n  Chế độ chăm sóc y tế, bảo hiểm sức khỏe."), _c('br'), _vm._v("\n  Khám sức khỏe hàng năm, trà chiều hàng ngày"), _c('br'), _vm._v("\n  Đầy đủ chế độ bảo hiểm, Phúc Lợi theo quy định pháp luật."), _c('br'), _vm._v("\n  Tham gia các hoạt động, phong trào của Công Ty."), _c('br'), _vm._v("\n  Chính sách du lịch, nghỉ mát trong năm."), _c('br')]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h1', [_vm._v("\n  JOB TITLE: TRỢ LÝ VẬN HÀNH (Tiếng Trung)\n  ")]), _vm._v(" "), _c('h3', [_vm._v("\n  MIÊU TẢ CÔNG VIỆC\n  ")]), _vm._v(" "), _c('p', [_vm._v("\n  Vận hành và tối ưu sản phẩm (app)"), _c('br'), _vm._v("\n  Quản lý chất lượng, tính năng trên ứng dụng"), _c('br'), _vm._v("\n  Hỗ trợ test các tính năng mới."), _c('br'), _vm._v("\n  Thu thập phản hồi từ người dùng và thực hiện các khảo sát online."), _c('br'), _vm._v("\n  Đề xuất giải pháp để nâng cao chất lượng sản phẩm."), _c('br')]), _vm._v(" "), _c('h3', [_vm._v("\n  YÊU CẦU CÔNG VIỆC\n  ")]), _vm._v(" "), _c('p', [_vm._v("\n  Ngôn ngữ: Tiếng Trung lưu loát, tiếng Anh căn bản;"), _c('br'), _vm._v("\n  Am hiểu và yêu thích mảng ứng dụng công nghệ, mạng truyền thông;"), _c('br'), _vm._v("\n  Thích khám phá và học hỏi;"), _c('br'), _vm._v("\n  Có ý chí phấn đấu và thử thách bản thân;"), _c('br'), _vm._v("\n  Kinh nghiệm làm việc ít nhất 1 năm."), _c('br'), _vm._v("\n  Tư duy nhạy bén, có khả năng lĩnh hội và thực hiện tốt yêu cầu của lãnh đạo. Có năng lực"), _c('br'), _vm._v("\n  tổ chức sắp xếp công việc."), _c('br'), _vm._v("\n  Cẩn thận, trung thực, chịu khó."), _c('br'), _vm._v("\n  Hợp tác và sẵn sàng giúp đỡ đồng nghiệp."), _c('br'), _vm._v("\n  Ứng viên phải có đạo đức nghề nghiệp và phẩm chất tốt."), _c('br')]), _vm._v(" "), _c('h3', [_vm._v("\n  PHÚC LỢI\n  ")]), _vm._v(" "), _c('p', [_vm._v("\n  Trợ cấp tiền cơm trưa : 30,000 vnđ/ngày; trợ cấp gửi xe : 300,000 vnđ/tháng."), _c('br'), _vm._v("\n  Chế độ đãi ngộ bao gồm chi phí điện thoại, tiếp khách, hỗ trợ khác.(Tùy vị trí)"), _c('br'), _vm._v("\n  Chế độ chăm sóc y tế, bảo hiểm sức khỏe."), _c('br'), _vm._v("\n  Khám sức khỏe hàng năm, trà chiều hàng ngày"), _c('br'), _vm._v("\n  Đầy đủ chế độ bảo hiểm, Phúc Lợi theo quy định pháp luật."), _c('br'), _vm._v("\n  Tham gia các hoạt động, phong trào của Công Ty."), _c('br'), _vm._v("\n  Chính sách du lịch, nghỉ mát trong năm."), _c('br')]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h1', [_vm._v("\n  JOB TITLE: TRỢ LÝ KINH DOANH (Tiếng Trung)\n  ")]), _vm._v(" "), _c('h3', [_vm._v("\n  MIÊU TẢ CÔNG VIỆC\n  ")]), _vm._v(" "), _c('p', [_vm._v("\n  Theo dõi tình trạng bán hàng trên toàn diện các mặt quảng cáo,"), _c('br'), _vm._v("\n  Hướng dẫn và hỗ trợ bán hàng để hoàn tất quy trình đặt chỗ quảng cáo."), _c('br'), _vm._v("\n  Đối với chiến dịch quảng cáo tiến hành giám sát và giám sát cạnh tranh."), _c('br'), _vm._v("\n  Đào tạo và quản lý toàn bộ quy trình quản lý và hệ thống hợp đồng bán hàng để phê duyệt"), _c('br'), _vm._v("\n  hợp đồng.Quản lý lợi nhuận bán hàng.\n  ")]), _vm._v(" "), _c('h3', [_vm._v("\n  YÊU CẦU CÔNG VIỆC\n  ")]), _vm._v(" "), _c('p', [_vm._v("\n  Ngôn ngữ : Tiếng Trung thành thạo"), _c('br'), _vm._v("\n  Tốt nghiệp cao đẳng trở lên, có 1năm kinh nghiệm trở lên. Ưu tiên các bạn có kinh nghiệm"), _c('br'), _vm._v("\n  làm trợ lý giám đốc, sale admin, thư ký kinh doanh... trong ngành Truyền thông, Báo chí ,"), _c('br'), _vm._v("\n  Event ..."), _c('br'), _vm._v("\n  Có kỹ năng đánh, lập văn bản cơ bản và một số kỹ năng thống kê và phân tích nhất định."), _c('br'), _vm._v("\n  Có tinh thần đồng đội, kính nghề và trách nhiệm."), _c('br'), _vm._v("\n  Ưu tiên sinh viên mới tốt nghiệp có thành tích xuất sắc."), _c('br')]), _vm._v(" "), _c('h3', [_vm._v("\n  PHÚC LỢI\n  ")]), _vm._v(" "), _c('p', [_vm._v("\n  Trợ cấp tiền cơm trưa : 30,000 vnđ/ngày; trợ cấp gửi xe : 300,000 vnđ/tháng."), _c('br'), _vm._v("\n  Chế độ đãi ngộ bao gồm chi phí điện thoại, tiếp khách, hỗ trợ khác.(Tùy vị trí)"), _c('br'), _vm._v("\n  Chế độ chăm sóc y tế, bảo hiểm sức khỏe."), _c('br'), _vm._v("\n  Khám sức khỏe hàng năm, trà chiều hàng ngày"), _c('br'), _vm._v("\n  Đầy đủ chế độ bảo hiểm, Phúc Lợi theo quy định pháp luật."), _c('br'), _vm._v("\n  Tham gia các hoạt động, phong trào của Công Ty."), _c('br'), _vm._v("\n  Chính sách du lịch, nghỉ mát trong năm."), _c('br')]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h1', [_vm._v("\n  JOB TITLE: NHÂN VIÊN KINH DOANH\n  ")]), _vm._v(" "), _c('h3', [_vm._v("\n  MÔ TẢ CÔNG VIỆC:\n  ")]), _vm._v(" "), _c('p', [_vm._v("\n  Dựa theo yêu cầu phát triển của công ty, phụ trách tìm kiếm, khai"), _c('br'), _vm._v("\n  thác khách hàng mới và giới thiệu các dịch vụ quảng cáo của VNNN"), _c('br'), _vm._v("\n  Tư vấn, đàm phán trực tiếp hoặc qua điện thoại, email,...cho khách"), _c('br'), _vm._v("\n  hàng để ký kết hợp đồng trong phạm vi chính sách cung cấp dịch vụ"), _c('br'), _vm._v("\n  của công ty"), _c('br'), _vm._v("\n  Có hiểu biết/sử dụng về ứng dụng điện thoại/thương mại điện tử và"), _c('br'), _vm._v("\n  chủ động phát triển khách hàng mới"), _c('br'), _vm._v("\n  Lập kế hoạch làm việc theo ngày, tuần, tháng và hoàn thành chỉ"), _c('br'), _vm._v("\n  tiêu được giao từ cấp trên trong kỳ đánh giá"), _c('br'), _vm._v("\n  Đảm nhận doanh số được giao và chịu trách nhiệm KPI theo tháng"), _c('br'), _vm._v("\n  Công việc cụ thể trao đổi thêm khi phỏng vấn."), _c('br'), _vm._v("\n  Sẽ được đào tạo kiến thức chuyên môn."), _c('br')]), _vm._v(" "), _c('h3', [_vm._v("\n    YÊU CẦU CÔNG VIỆC:\n  ")]), _vm._v(" "), _c('p', [_vm._v("\n  Ưu tiên có kiến thức trong ngành quảng cáo/marketing/ecomerce,game, không có kinh nghiệm được đào tạo"), _c('br'), _vm._v("\n  Tốt nghiệp cao đẳng trở lên"), _c('br'), _vm._v("\n  Có kỹ năng Tin học văn phòng."), _c('br'), _vm._v("\n  Có kỹ năng giao tiếp tốt."), _c('br'), _vm._v("\n  Chịu được áp lực trong công việc, chỉ tiêu doanh số KPI"), _c('br'), _vm._v("\n  Ham học hỏi, cầu tiến, linh hoạt nhạy bén trong công việc"), _c('br'), _vm._v("\n  Tiếng Trung/tiếng Anh giao tiếp tốt là một lợi thế"), _c('br')]), _vm._v(" "), _c('h3', [_vm._v("\n    PHÚC LỢI\n  ")]), _vm._v(" "), _c('p', [_vm._v("\n  Trợ cấp tiền cơm trưa : 30,000 vnđ/ngày; trợ cấp gửi xe : 300,000 vnđ/tháng."), _c('br'), _vm._v("\n  Chế độ đãi ngộ bao gồm chi phí điện thoại, tiếp khách, hỗ trợ khác.(Tùy vị trí)"), _c('br'), _vm._v("\n  Chế độ chăm sóc y tế, bảo hiểm sức khỏe."), _c('br'), _vm._v("\n  Khám sức khỏe hàng năm, trà chiều hàng ngày"), _c('br'), _vm._v("\n  Đầy đủ chế độ bảo hiểm, Phúc Lợi theo quy định pháp luật."), _c('br'), _vm._v("\n  Tham gia các hoạt động, phong trào của Công Ty."), _c('br'), _vm._v("\n  Chính sách du lịch, nghỉ mát trong năm."), _c('br')]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h1', [_vm._v("\n    JOB TITLE: NHÂN VIÊN KINH DOANH (Tiếng Trung)\n  ")]), _vm._v(" "), _c('h3', [_vm._v("\n    MÔ TẢ CÔNG VIỆC:\n  ")]), _vm._v(" "), _c('p', [_vm._v("\n    Phụ trách sales quảng cáo trên nền tảng ứng dụng có sẵn của công ty."), _c('br'), _vm._v("\n    Có khả năng tìm kiếm và chủ động phát triển nguồn khách hàng mới có nhu cầu quảng cáo trên app ứng dụng."), _c('br'), _vm._v("\n    Tích cực trao đổi và đáp ứng nhu cầu quảng cáo của khách hàng."), _c('br')]), _vm._v(" "), _c('h3', [_vm._v("\n  YÊU CẦU CÔNG VIỆC:\n  ")]), _vm._v(" "), _c('p', [_vm._v("\n  Có 1-2 năm kinh nghiệm Sales các ngành BĐS, Tài chính, Bảo hiểm, Dược, Game, Sales Corporate…và các ngành dịch vụ liên quan."), _c('br'), _vm._v("\n  Ưu tiên ứng viên có kiến thức về ngành truyền thông và kĩ năng sale quảng cáo truyền thông. "), _c('br'), _vm._v("\n  Có thể chịu áp lực doanh số và hoàn thành các chỉ tiêu kinh doanh được giao. "), _c('br'), _vm._v("\n  Kĩ năng sales, kỹ năng giao tiếp, đàm phán và trình bày tốt, "), _c('br'), _vm._v("\n  Ưu tiên ứng viên giao tiếp được bằng tiếng Trung và có thể bắt đầu nhận việc ngay."), _c('br')]), _vm._v(" "), _c('h3', [_vm._v("\n  PHÚC LỢI\n  ")]), _vm._v(" "), _c('p', [_vm._v("\n  Trợ cấp tiền cơm trưa : 30,000 vnđ/ngày; trợ cấp gửi xe : 300,000 vnđ/tháng."), _c('br'), _vm._v("\n  Chế độ đãi ngộ bao gồm chi phí điện thoại, tiếp khách, hỗ trợ khác.(Tùy vị trí)"), _c('br'), _vm._v("\n  Chế độ chăm sóc y tế, bảo hiểm sức khỏe."), _c('br'), _vm._v("\n  Khám sức khỏe hàng năm, trà chiều hàng ngày"), _c('br'), _vm._v("\n  Đầy đủ chế độ bảo hiểm, Phúc Lợi theo quy định pháp luật."), _c('br'), _vm._v("\n  Tham gia các hoạt động, phong trào của Công Ty."), _c('br'), _vm._v("\n  Chính sách du lịch, nghỉ mát trong năm."), _c('br')]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h1', [_vm._v("\n  JOB TITLE: MANAGEMENT TRAINEE\n  ")]), _vm._v(" "), _c('h3', [_vm._v("\n  MÔ TẢ CÔNG VIỆC:\n  ")]), _vm._v(" "), _c('p', [_vm._v("\n  Hỗ trợ thiết lập và thực hiện hệ thống phát triển bán hàng."), _c('br'), _vm._v("\n  Phụ trách sales quảng cáo trên nền tảng ứng dụng có sẵn của công ty."), _c('br'), _vm._v("\n  Có khả năng tìm kiếm và chủ động phát triển nguồn khách hàng mới có nhu cầu quảng cáo trên app ứng dụng."), _c('br'), _vm._v("\n  Tích cực trao đổi và đáp ứng nhu cầu quảng cáo của khách hàng"), _c('br')]), _vm._v(" "), _c('h3', [_vm._v("\n  YÊU CẦU CÔNG VIỆC:\n  ")]), _vm._v(" "), _c('p', [_vm._v("\n  Chưa có kinh nghiệm sẽ được đào tạo\n  Ưu tiên du học sinh Trung Quốc (được đào tạo thành Sales Management)"), _c('br'), _vm._v("\n  Tính cách hướng ngoại, sẵn sàng làm việc ở vị trí sale ít nhất 2 năm"), _c('br'), _vm._v("\n  Ưu tiên ứng viên co kiến thức về ngành truyền thông và kĩ năng sale quảng cáo truyền thông."), _c('br'), _vm._v("\n  Có thể chịu áp lực doanh số và hoàn thành các chỉ tiêu kinh doanh được giao."), _c('br'), _vm._v("\n  Kỹ năng sales, kỹ năng giao tiếp, đàm phán và trình bày tốt."), _c('br'), _vm._v("\n  Ưu tiên ứng viên giao tiếp được bằng tiếng Anh /Trung và có thể bắt đầu nhận việc ngay."), _c('br')]), _vm._v(" "), _c('h3', [_vm._v("\n  PHÚC LỢI\n  ")]), _vm._v(" "), _c('p', [_vm._v("\n  Trợ cấp tiền cơm trưa : 30,000 vnđ/ngày; trợ cấp gửi xe : 300,000 vnđ/tháng."), _c('br'), _vm._v("\n  Chế độ đãi ngộ bao gồm chi phí điện thoại, tiếp khách, hỗ trợ khác.(Tùy vị trí)"), _c('br'), _vm._v("\n  Chế độ chăm sóc y tế, bảo hiểm sức khỏe."), _c('br'), _vm._v("\n  Khám sức khỏe hàng năm, trà chiều hàng ngày"), _c('br'), _vm._v("\n  Đầy đủ chế độ bảo hiểm, Phúc Lợi theo quy định pháp luật."), _c('br'), _vm._v("\n  Tham gia các hoạt động, phong trào của Công Ty."), _c('br'), _vm._v("\n  Chính sách du lịch, nghỉ mát trong năm."), _c('br')]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h1', [_vm._v("\n  JOB TITLE: MEDIA BOOKING\n  ")]), _vm._v(" "), _c('h3', [_vm._v("\n    MÔ TẢ CÔNG VIỆC\n  ")]), _vm._v(" "), _c('p', [_vm._v("\n  Tìm kiếm các nguồn traffic hiệu quả cao;"), _c('br'), _vm._v("\n  Tìm kiếm và phát triển mối quan hệ và xây dựng lưới publishers (mobile app, web…);"), _c('br'), _vm._v("\n  Chịu trách nhiệm kiểm tra vận hành của các publisher, hỗ trợ khi gặp vấn đề."), _c('br'), _vm._v("\n  Đàm phán, kiểm soát chi phí và ngân sách cho các đợt quảng cáo;"), _c('br'), _vm._v("\n  Giám sát hiệu quả của các chiến dịch quảng cáo;"), _c('br'), _vm._v("\n  Nắm vai trò giao dịch, tương tác, kết nối với đối tác quảng cáo, publisher để tối ưu hóa nguồn"), _c('br'), _vm._v("\n  traffic;"), _c('br'), _vm._v("\n  Các nhiệm vụ khác được giao.\n  ")]), _vm._v(" "), _c('h3', [_vm._v("\n  YÊU CẦU CÔNG VIỆC\n  ")]), _vm._v(" "), _c('p', [_vm._v("\n  Tốt nghiệp Đại Học chuyên ngành Marketing hoặc Quảng Cáo"), _c('br'), _vm._v("\n  Có kinh nghiệm tìm kiếm, thương lượng và làm việc với các công ty đối tác quảng cáo, publishers"), _c('br'), _vm._v("\n  (app, web...);"), _c('br'), _vm._v("\n  Ưu tiên ứng viên có ít nhất 1 năm kinh nghiệm trong mảng Digital marketing, ưu tiên ứng viên đã từng làm trong các Agency về Digital marketing;"), _c('br'), _vm._v("\n  Tư duy logic, có kiến thức cơ bản về Sale và Marketing;"), _c('br'), _vm._v("\n  Ưu tiên ứng viên có khả năng giao tiếp bằng tiếng Anh;"), _c('br'), _vm._v("\n  Hiểu biết về thị trường quảng cáo tại Việt Nam (hiểu về sản phẩm, về đối thủ và các hình thức chạy hiện nay);"), _c('br'), _vm._v("\n  Quan hệ tốt với các công ty quảng cáo, publishers;"), _c('br'), _vm._v("\n  Kỹ năng giao tiếp, trình bày và thương lượng, đàm phán tốt;"), _c('br'), _vm._v("\n  Có khả năng tìm kiếm, phân tích thông tin và đặc biệt là thông tin trong ngành quảng cáo;"), _c('br'), _vm._v("\n  Tư duy logic, nhanh nhẹn, nhìn nhận vấn đề tổng quan, nhanh chóng nắm bắt được và giải quyết vấn đề hiệu quả;"), _c('br'), _vm._v("\n  Chăm chỉ, chịu khó và có khả năng làm việc dưới áp lực cao."), _c('br')]), _vm._v(" "), _c('h3', [_vm._v("\n  PHÚC LỢI\n  ")]), _vm._v(" "), _c('p', [_vm._v("\n  Trợ cấp tiền cơm trưa : 30,000 vnđ/ngày; trợ cấp gửi xe : 300,000 vnđ/tháng."), _c('br'), _vm._v("\n  Chế độ đãi ngộ bao gồm chi phí điện thoại, tiếp khách, hỗ trợ khác.(Tùy vị trí)"), _c('br'), _vm._v("\n  Chế độ chăm sóc y tế, bảo hiểm sức khỏe."), _c('br'), _vm._v("\n  Khám sức khỏe hàng năm, trà chiều hàng ngày"), _c('br'), _vm._v("\n  Đầy đủ chế độ bảo hiểm, Phúc Lợi theo quy định pháp luật."), _c('br'), _vm._v("\n  Tham gia các hoạt động, phong trào của Công Ty."), _c('br'), _vm._v("\n  Chính sách du lịch, nghỉ mát trong năm."), _c('br')]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h1', [_vm._v("\n  JOB TITLE: SALES BRAND\n  ")]), _vm._v(" "), _c('h3', [_vm._v("\n  MÔ TẢ CÔNG VIỆC\n  ")]), _vm._v(" "), _c('p', [_vm._v("\n  Phụ trách sale về ngành này trên nền tảng ứng dụng di động có sẵn của công ty."), _c('br'), _vm._v("\n  Thông thuộc thị trường ứng dụng điện thoại/thương mại điện tử, có nguồn khách hàng trong ngành, có kinh nghiệm hợp tác quảng cáo trong ngành ứng dụng điện thoại/thương mại điện tử ( Ít nhất một đối tác trở lên)"), _c('br'), _vm._v("\n  Có thể chủ động phát triển khách hàng mới."), _c('br'), _vm._v("\n  Tích cực trao đổi và đáp ứng nhu cầu của khách hàng."), _c('br')]), _vm._v(" "), _c('h3', [_vm._v("\n  YÊU CẦU CÔNG VIỆC\n  ")]), _vm._v(" "), _c('p', [_vm._v("\n  Tốt nghiệp đại học trở lên, có 2-5 năm kinh nghiệm sale quảng cáo. "), _c('br'), _vm._v("\n  Đã có kinh nghiệm bán thành công quảng cáo, có khách hàng đối tác. "), _c('br'), _vm._v("\n  Kĩ năng giao tiếp tốt, kiến thức về ngành truyền thông và kĩ năng sale quảng cáo truyền thông. "), _c('br'), _vm._v("\n  Có thể chịu áp lực nhất động và hoàn thành các chỉ tiêu hiệu suất của bộ phận. "), _c('br'), _vm._v("\n  Kỹ năng office văn phòng tốt, có kinh nghiệm làm PPT."), _c('br')]), _vm._v(" "), _c('h3', [_vm._v("\n  PHÚC LỢI\n  ")]), _vm._v(" "), _c('p', [_vm._v("\n  Trợ cấp tiền cơm trưa : 30,000 vnđ/ngày; trợ cấp gửi xe : 300,000 vnđ/tháng."), _c('br'), _vm._v("\n  Chế độ đãi ngộ bao gồm chi phí điện thoại, tiếp khách, hỗ trợ khác.(Tùy vị trí)"), _c('br'), _vm._v("\n  Chế độ chăm sóc y tế, bảo hiểm sức khỏe."), _c('br'), _vm._v("\n  Khám sức khỏe hàng năm, trà chiều hàng ngày"), _c('br'), _vm._v("\n  Đầy đủ chế độ bảo hiểm, Phúc Lợi theo quy định pháp luật."), _c('br'), _vm._v("\n  Tham gia các hoạt động, phong trào của Công Ty."), _c('br'), _vm._v("\n  Chính sách du lịch, nghỉ mát trong năm."), _c('br')]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "18px",
      "color": "red"
    }
  }, [_c('b', [_vm._v("\n      Thông tin thêm:"), _c('br'), _vm._v("\n      Địa điểm làm việc: Tầng 1, E.Town Central, 11 Doan Van Bo Street, 12"), _c('br'), _vm._v("\n      Ward, District4, Ho Chi Minh City, Vietnam."), _c('br'), _vm._v("\n      Thời gian làm việc: Thứ 2 – Thứ 6 (9h-18h00) & Thứ 7 (8h30-12h30)"), _c('br'), _vm._v("\n      Liên hệ:     Phòng Nhân sự: 02836362034"), _c('br'), _vm._v("\n                         Mr.Thành Công: 0981190272"), _c('br'), _vm._v("\n                         Email: Tuyendung@vngaynay.vn"), _c('br')])])])
}]}

/***/ }),

/***/ 911:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "swiper-container"
  }, [_vm._t("parallax-bg"), _vm._v(" "), _c('div', {
    class: _vm.defaultSwiperClasses.wrapperClass
  }, [_vm._t("default")], 2), _vm._v(" "), _vm._t("pagination"), _vm._v(" "), _vm._t("button-prev"), _vm._v(" "), _vm._t("button-next"), _vm._v(" "), _vm._t("scrollbar")], 2)
},staticRenderFns: []}

/***/ }),

/***/ 912:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "winner",
    staticClass: "winner"
  }, [_c('loading', {
    attrs: {
      "active": _vm.isLoading,
      "can-cancel": false,
      "loader": "dots",
      "color": "#1f9ed3",
      "is-full-page": _vm.fullPage
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "current-info"
  }, [_c('h4', [_vm._v("Tuần số: "), _c('span', {
    staticClass: "times"
  }, [_vm._v(_vm._s(_vm.times))])]), _vm._v(" "), _c('span', {
    staticClass: "info"
  }, [_vm._v("Mã dự thưởng của bạn:")]), _vm._v(" "), _c('div', {
    staticClass: "ticket-info"
  }, [_vm._v(_vm._s(_vm.ticketid))])]), _vm._v(" "), (_vm.ticket && _vm.ticket.length > 1) ? _c('div', {
    staticClass: "last-info"
  }, [_c('h4', [_vm._v("Tuần mở thưởng trước: Tuần số "), _c('span', {
    staticClass: "times"
  }, [_vm._v(_vm._s(_vm.ticket && _vm.ticket[1].issue || 'xx') + " ")])]), _vm._v(" "), _c('span', {
    staticClass: "info"
  }, [_vm._v("Mã dự thưởng của bạn:")]), _vm._v(" "), _c('div', {
    staticClass: "ticket-info"
  }, [_vm._v(_vm._s(_vm.ticket && _vm.ticket[1].lottery || 'xxxxxx'))]), _vm._v(" "), _c('h4', {
    staticClass: "info"
  }, [_vm._v("Tình trạng giải thưởng:")]), _vm._v(" "), _c('div', {
    staticClass: "win-status"
  }, [_vm._v(_vm._s(_vm.ticket.status === 0 ? "Không trúng thưởng" : "Không trúng thưởng"))])]) : _c('div', {
    staticClass: "last-info"
  }, [_vm._m(0)])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', [_vm._v("Tuần mở thưởng trước: "), _c('span', {
    staticClass: "times"
  }, [_vm._v("Không tham gia")])])
}]}

/***/ }),

/***/ 913:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "sub-list list-reset"
  }, _vm._l((_vm.data), function(item) {
    return _c('li', {
      key: item.id
    }, [_c('a', {
      attrs: {
        "href": item.origin_url,
        "target": "_blank"
      }
    }, [_c('div', {
      staticClass: "mt0 mb1 item-title",
      attrs: {
        "title": item.title,
        "data-clamp": "2"
      }
    }, [_vm._v(_vm._s(item.title))])]), _c('div', {
      staticClass: "sub"
    }, [_vm._v(_vm._s(item.pub_source)), _c('span', {
      staticClass: "px1"
    }, [_vm._v("|")]), _vm._v(_vm._s(_vm.formatUtc(item.pub_utc)))])])
  }))
},staticRenderFns: []}

/***/ }),

/***/ 914:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.articleList.length > 0) ? _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "list-title"
  }, [_vm._v("PR Newswire")]), _c('ul', {
    staticClass: "list-reset content-list"
  }, _vm._l((_vm.articleList), function(item, idx) {
    return _c('li', {
      key: item.isoDate,
      staticClass: "list-item"
    }, [_c('a', {
      attrs: {
        "href": item.link,
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(item.title))])])
  }))]) : _vm._e()
},staticRenderFns: []}

/***/ }),

/***/ 915:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "iphoneBox"
  }, [_c('header', [_c('h2', [_vm._v("Khi đủ điều kiện tham gia chương trình,")]), _vm._v(" "), _c('h3', [_vm._v("người chơi nhận được mã số dự thưởng N")]), _vm._v(" "), _c('img', {
    staticClass: "introduction_banner",
    attrs: {
      "src": __webpack_require__(877),
      "alt": "gift"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "rule"
  }, [_c('ul', {
    staticClass: "ruleContent"
  }, [_c('li', [_c('h4', [_vm._v("1.Cách thực tiến hành chương trình khuyến mại và tham gia để trúng thưởng:")]), _vm._v(" "), _c('p', [_vm._v("Người dùng đăng ký tham gia chương trình với tài khoản Facebook của mình bằng cách thao tác trên: http://vngaynay.vn/ theo các bước như sau.")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("- Bước 1: Truy cập vào đường link: http://vngaynay.vn/. Click chọn “đăng nhập bằng tài khoản facebook”. Sau khi đăng nhập thành công chuyển sang bước 2.")]), _vm._v(" "), _c('li', [_vm._v("- Bước 2: Hệ thống sẽ tự động chuyển sang giao diện mới với thông báo “Tham gia chương trình khuyến mại Đọc tin hay, rinh quà liền tay” và khách hàng có thể điền các thông tin bắt buộc sau: Họ và tên, số chứng minh nhân dân, số điện thoại, địa chỉ email. Sau khi điền xong khách hàng lick vào nút “Gửi”. Nếu thông tin hợp lệ hệ thống sẽ gửi thông  báo về với nội dung “Cảm ơn quý khách đã tham gia chương trình khuyến mại Đọc tin hay, rinh quà liền tay của công ty TNHH Công Nghệ Mạng Thông Tin Việt Nam.")]), _vm._v(" "), _c('li', [_vm._v("- Bước 3: Sau khi đăng ký tham gia chương trình quý khách hàng thực hiện các thao tác sau để nhận mã quay số trúng thưởng.")])]), _vm._v(" "), _c('p', [_vm._v("Người dùng chia sẻ bài viết lên trang Facebook cá nhân ở chế độ công khai, hoặc chia sẻ cho bạn bè trên Facebook, người dùng sẽ được tích lũy điểm kinh vào tài khoản Facebook đã được ghi nhận trên hệ thống.")]), _vm._v(" "), _c('div', [_c('p', [_vm._v(" Cách tích lũy điểm")]), _vm._v(" "), _c('table', {
    staticClass: "tableInfo",
    attrs: {
      "rules": "all"
    }
  }, [_c('tr', [_c('th', [_vm._v("Thao tác")]), _vm._v(" "), _c('th', [_vm._v("Số điểm cộng")]), _vm._v(" "), _c('th', [_vm._v("Ghi chú")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Chia sẻ bài viết lên Facebook cá nhân để ở chế độ công khai")]), _vm._v(" "), _c('td', [_vm._v("2")]), _vm._v(" "), _c('td', [_vm._v("Mỗi ngày được cộng tối đa 10 điểm")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Chia sẻ bài viết cho bạn bè bằng hai cách sau: Đăng lên tường bạn bè hoặc gửi qua tin nhắn face book.")]), _vm._v(" "), _c('td', [_vm._v("1")]), _vm._v(" "), _c('td', [_vm._v("Mỗi ngày được cộng tối đa 20 điểm")])])])]), _vm._v(" "), _c('p', [_vm._v("Mỗi tuần tích lũy đủ 50 điểm kinh nghiệm, sẽ được hệ thống tặng 01 mã số dự thưởng qua Facebook cá nhân của người dùng. Không giới hạn mã số dự thưởng.Mẫu mã số dự thưởng như sau: Bao gồm 7 ký tự chữ số: VD: 1234567.")])]), _vm._v(" "), _c('li', [_c('h4', [_vm._v("2.Thời gian thực hiện của chương trình khuyến mại:")]), _vm._v(" "), _c('ol', [_c('li', [_vm._v("Thời gian thực hiện chương trình: 0h ngày 05/11/2018 đến 0h ngày 30/06/2019")]), _vm._v(" "), _c('li', [_vm._v("Hạn chót tham gia dự thưởng: 23h59 phút chủ nhật hàng tuần")]), _vm._v(" "), _c('li', [_vm._v("Thời gian công bố giải thưởng: 17h thứ Hai hàng tuần")]), _vm._v(" "), _c('li', [_vm._v("Thời gian trao giải: 15 ngày làm việc kể từ ngày có kết quả của từng đợt quay thưởng.")])])]), _vm._v(" "), _c('li', [_c('h4', [_vm._v("3.Quy định về mã số trúng thưởng:")]), _vm._v(" "), _c('p', [_vm._v("Khi bạn tham gia đổi thưởng, hệ thống sẽ phát một dãy số gồm 7 chữ số, gọi là vé dự thưởng.")]), _vm._v(" "), _c('p', [_vm._v("Việc quay thưởng được thực hiện công khai để chọn ra người chiến thắng trên Fanpage: https://www.facebook.com/vngaynay/")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("Thời gian: 17h ngày 01/7/2019;")]), _vm._v(" "), _c('li', [_vm._v("Địa điểm: Trang Fanpage chính thức của Báo Hay 24h (link:https://www.facebook.com/vngaynay/\nMỗi tuần một sản phẩm, chỉ có 01 giải được trao.")])])]), _vm._v(" "), _c('li', [_c('h4', [_vm._v("4. Cơ cấu giải thưởng:")]), _vm._v(" "), _c('table', {
    staticClass: "tableInfo",
    attrs: {
      "rules": "all"
    }
  }, [_c('tr', [_c('th', [_vm._v("Cơ cấu giải thưởng")]), _vm._v(" "), _c('th', [_vm._v("Nội dung giải thưởng ")]), _vm._v(" "), _c('th', [_vm._v("Trị giá giải thưởng (VNĐ) ")]), _vm._v(" "), _c('th', [_vm._v("Số giải")]), _vm._v(" "), _c('th', [_vm._v("Thành tiền (VNĐ)")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Giải nhất\t")]), _vm._v(" "), _c('td', [_vm._v("Xe máy Wave RSX FI 2017 (phiên bản phanh đĩa vành nan hoa) + 4.500.000 VNĐ\n                  Hoặc\n                  Điện thoại iPhone X 64GB Gray")]), _vm._v(" "), _c('td', [_vm._v("26.990.000")]), _vm._v(" "), _c('td', [_vm._v("34")]), _vm._v(" "), _c('td', [_vm._v("917.660.000")])])])])])])])
}]}

/***/ }),

/***/ 916:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "mt0 list-reset sticky-list"
  }, _vm._l((_vm.data), function(item, idx) {
    return _c('li', {
      key: item.id,
      staticClass: "mb2 sticky-item"
    }, [_c('div', {
      staticClass: "primary-info"
    }, [_c('a', {
      attrs: {
        "href": item.origin_url,
        "target": "_blank"
      }
    }, [_c('div', {
      staticClass: "mt0 mb1 item-title",
      attrs: {
        "title": item.title,
        "data-clamp": "3"
      }
    }, [_vm._v(_vm._s(item.title))])])]), _c('div', {
      staticClass: "primary-img"
    }, [_c('a', {
      attrs: {
        "href": item.origin_url,
        "target": "_blank"
      }
    }, [_c('img', {
      staticClass: "fit",
      attrs: {
        "src": _vm.shift(item.o_pic_list[0])
      }
    })])])])
  }))
},staticRenderFns: []}

/***/ }),

/***/ 917:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app-download"
  }, [_c('a', {
    attrs: {
      "href": "https://thtopnews.onelink.me/sfeV?pid=news_official&c=news_official",
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  })])
}]}

/***/ }),

/***/ 918:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('page-header', {
    attrs: {
      "cids": _vm.cids,
      "isLogin": _vm.loginSys.isLogin,
      "userName": _vm.userInfo.name
    }
  }), _c('transition', {
    attrs: {
      "enter-active-class": "animated fadeIn"
    }
  }, [_c('router-view')], 1), _c('page-footer'), _c('el-dialog', {
    attrs: {
      "custom-class": "dialog-login",
      "visible": _vm.dialogTableVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogTableVisible = $event
      },
      "close": _vm.dialogLoginClose
    }
  }, [(_vm.loginSys.stat === 'login') ? _c('login') : _vm._e(), (_vm.loginSys.stat === 'signup') ? _c('signup') : _vm._e()], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 919:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', [_c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "flex items-start justify-between"
  }, [_c('div', {
    staticClass: "col-8 connten-left"
  }, [_c('h3', [_vm._v("ติดต่อเรา")]), _c('ul', {
    staticClass: "list-reset"
  }, [_c('li', {
    staticClass: "flex items-start"
  }, [_c('label', {
    staticClass: "item-label"
  }, [_vm._v("อีเมลล์:")]), _c('div', {
    staticClass: "item-content"
  }, [_vm._v("thaidaily2020@gmail.com")])]), _c('li', {
    staticClass: "flex items-start"
  }, [_c('label', {
    staticClass: "item-label"
  }, [_vm._v("Line:")]), _c('div', {
    staticClass: "item-content"
  }, [_vm._v("thaidaily777")])]), _c('li', {
    staticClass: "flex items-start"
  }, [_c('label', {
    staticClass: "item-label"
  }, [_vm._v("ที่อยู่ :")]), _c('div', {
    staticClass: "item-content"
  }, [_vm._v("388/64 Nuan Chan Rd, Nuanchan, Bueng Kum, Bangkok 10230.")])])])])])])])
}]}

/***/ }),

/***/ 920:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "winner",
    staticClass: "winner"
  }, [_c('table', [_vm._m(0), _vm._v(" "), _vm._l((_vm.list), function(item) {
    return _c('tr', {
      key: item.number
    }, [_c('td', [_vm._v(_vm._s(item.date))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.number))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.tel))])])
  })], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('th', [_vm._v("Ngày quay\t")]), _vm._v(" "), _c('th', [_vm._v("Mã trúng thưởng\t")]), _vm._v(" "), _c('th', [_vm._v("Di động")])])
}]}

/***/ }),

/***/ 921:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "questionBox"
  }, [_c('loading', {
    attrs: {
      "active": _vm.isLoading,
      "can-cancel": false,
      "loader": "dots",
      "color": "#1f9ed3",
      "is-full-page": _vm.fullPage
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('main', {
    staticClass: "main-form"
  }, [_c('form', {
    attrs: {
      "name": "userInfo"
    }
  }, [_c('table', {
    staticClass: "main-table"
  }, [_c('tr', [_c('td', [_vm._v("Họ tên *:")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.name),
      expression: "name"
    }],
    attrs: {
      "type": "text",
      "value": ""
    },
    domProps: {
      "value": (_vm.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.name = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Số CMND*:")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cardid),
      expression: "cardid"
    }],
    attrs: {
      "type": "text",
      "value": ""
    },
    domProps: {
      "value": (_vm.cardid)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.cardid = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Di động*:")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cellphone),
      expression: "cellphone"
    }],
    attrs: {
      "type": "text",
      "value": ""
    },
    domProps: {
      "value": (_vm.cellphone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.cellphone = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Email*:")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    attrs: {
      "type": "text",
      "value": ""
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('button', {
    staticClass: "submitBtn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.submitInfo($event)
      }
    }
  }, [_vm._v("Gửi")]), _vm._v(" "), _c('a', {
    on: {
      "click": _vm.goHome
    }
  }, [_vm._v("Bỏ qua>>")])])])]), _vm._v(" "), _c('p', [_vm._v("Tìm hiểu thêm về thể lệ chương trình khuyến mại "), _c('a', {
    on: {
      "click": _vm.jumpActive
    }
  }, [_vm._v("tại đây")]), _vm._v("!")])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "header-banner"
  }, [_c('img', {
    staticClass: "activeImg",
    attrs: {
      "src": __webpack_require__(876),
      "alt": "active"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "activeImg_tips"
  }, [_vm._v("0h ngày 05/11/2018 đến 0h ngày 30/06/2019")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', [_vm._v("\n    Chỉ bằng cách điền các thông tin dưới đây sẽ có thể tham gia chương trình khuyến mại cùng\n    "), _c('a', {
    attrs: {
      "href": "http://www.vngaynay.vn",
      "target": "blank"
    }
  }, [_vm._v("www.vngaynay.vn")]), _vm._v(" và có cơ hội nhận xe máy Wave RSX FI 2017 hoặc Điện thoại iPhone X 64GB Gray!\n  ")])
}]}

/***/ }),

/***/ 922:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gameBox"
  }, [_c('div', {
    staticClass: "gameHeader"
  }, [_c('a', {
    staticClass: "iphone",
    on: {
      "click": _vm.jumpIphone
    }
  }, [_vm._v("Xem chi tiết chương trình >>")]), _vm._v(" "), _c('a', {
    staticClass: "winner",
    on: {
      "click": _vm.jumpWinner
    }
  }, [_vm._v("Kết quả quay số trúng thưởng >>")])]), _vm._v(" "), _vm._m(0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gameFooter"
  }, [_c('p', [_vm._v("THỜI HẠN CHƯƠNG TRÌNH: 05/11/2018 – 30/06/2019")]), _vm._v(" "), _c('button', [_c('a', {
    attrs: {
      "href": "https://play.google.com/store/apps/details?id=com.xb.topnews"
    }
  }, [_vm._v("Tải ngay")])])])
}]}

/***/ }),

/***/ 923:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    attrs: {
      "id": "admzone492509"
    }
  })])
}]}

/***/ }),

/***/ 924:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-form', {
    ref: "userInfo",
    attrs: {
      "label-width": "120px",
      "model": _vm.userInfo,
      "rules": _vm.userInfoRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Tên đăng nhập",
      "prop": "account"
    }
  }, [_c('el-input', {
    staticClass: "col-10",
    attrs: {
      "name": "name"
    },
    model: {
      value: (_vm.userInfo.account),
      callback: function($$v) {
        _vm.userInfo.account = $$v
      },
      expression: "userInfo.account"
    }
  })], 1), _c('el-form-item', {
    attrs: {
      "label": "Mật khẩu",
      "prop": "password"
    }
  }, [_c('el-input', {
    staticClass: "col-10",
    attrs: {
      "type": "password",
      "name": "password"
    },
    model: {
      value: (_vm.userInfo.password),
      callback: function($$v) {
        _vm.userInfo.password = $$v
      },
      expression: "userInfo.password"
    }
  })], 1), _c('el-form-item', {
    staticClass: "mb0"
  }, [_c('div', {
    staticClass: "col-10"
  }, [_c('el-button', {
    staticClass: "col-12",
    attrs: {
      "type": "danger",
      "loading": _vm.loading
    },
    on: {
      "click": _vm.handleLogin
    }
  }, [_vm._v("Đăng nhập")]), _c('a', {
    staticClass: "right",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        _vm.handleLoginButton('signup')
      }
    }
  }, [_vm._v("Đăng ký")])], 1)])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 925:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "adTrue",
    staticClass: "ad-true"
  }, [_c('div', {
    attrs: {
      "id": "adtrue_tag_11562"
    }
  })])
},staticRenderFns: []}

/***/ }),

/***/ 926:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "userInfo"
  }, [_c('el-form', {
    ref: "form",
    attrs: {
      "action": "",
      "model": _vm.form,
      "label-width": "250px",
      "width": "1000px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "NickName"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.form.name),
      callback: function($$v) {
        _vm.form.name = $$v
      },
      expression: "form.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Giới tính"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.form.sex),
      callback: function($$v) {
        _vm.form.sex = $$v
      },
      expression: "form.sex"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "Nam"
    }
  }), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "Nữ"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Ngày sinh"
    }
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "date",
      "placeholder": "Chọn ngày"
    },
    model: {
      value: (_vm.form.date),
      callback: function($$v) {
        _vm.form.date = $$v
      },
      expression: "form.date"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Địa chỉ"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.form.adress),
      callback: function($$v) {
        _vm.form.adress = $$v
      },
      expression: "form.adress"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Số CMND/CCCD  *"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.form.idno),
      callback: function($$v) {
        _vm.form.idno = $$v
      },
      expression: "form.idno"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Nơi cấp CMND/CCCD"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.form.idnoFrom),
      callback: function($$v) {
        _vm.form.idnoFrom = $$v
      },
      expression: "form.idnoFrom"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Ngày cấp CMND/CCCD"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.form.idnoDate),
      callback: function($$v) {
        _vm.form.idnoDate = $$v
      },
      expression: "form.idnoDate"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Email *"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.form.email),
      callback: function($$v) {
        _vm.form.email = $$v
      },
      expression: "form.email"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Số điện thoại"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.form.phone),
      callback: function($$v) {
        _vm.form.phone = $$v
      },
      expression: "form.phone"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Ảnh đại diện"
    }
  }, [_c('el-upload', {
    ref: "upload",
    staticClass: "upload-demo",
    attrs: {
      "list-type": "picture",
      "limit": "1",
      "on-change": _vm.handleChange,
      "on-remove": _vm.handleRemove,
      "file-list": _vm.form.fileList,
      "auto-upload": false
    }
  }, [(_vm.form.fileList.length === 0) ? _c('el-button', {
    attrs: {
      "size": "small",
      "type": "primary"
    },
    slot: "trigger"
  }, [_vm._v("Chọn ảnh")]) : _vm._e()], 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-checkbox', {
    model: {
      value: (_vm.form.checked),
      callback: function($$v) {
        _vm.form.checked = $$v
      },
      expression: "form.checked"
    }
  }, [_vm._v("Tôi đã đọc kỹ và hoàn toàn đồng ý với "), _c('a', {
    attrs: {
      "href": "/Agreement.pdf",
      "target": "_blank"
    }
  }, [_vm._v("Thỏa Thuận Cung Cấp và Sử Dụng Dịch Vụ của Báo Hay 24h")]), _vm._v(". ")])], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.onSubmit
    }
  }, [_vm._v("Submit")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 927:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "current-info"
  }, [_c('h4', [_vm._v("Tuần số: "), _c('span', {
    staticClass: "times"
  }, [_vm._v(_vm._s(_vm.times))])]), _vm._v(" "), _c('span', {
    staticClass: "info"
  }, [_vm._v("Mã dự thưởng của bạn:")]), _vm._v(" "), _c('div', {
    staticClass: "ticket-info"
  }, [_vm._v(_vm._s(_vm.ticketid))])]), _vm._v(" "), _c('div', {
    staticClass: "detailBox"
  }, [_c('p', [_vm._v("Cảm ơn quý khách đã tham gia chương trình khuyến mại Đọc tin hay, rinh quà liền tay của công ty TNHH Công Nghệ Mạng Thông Tin Việt Nam. Mọi thông tin về thể lệ chương trình quý khách hàng truy cập vào đường link: "), _c('a', {
    on: {
      "click": _vm.jumpActive
    }
  }, [_vm._v("https://vngaynay.vn/#/introduction.html")]), _vm._v(" hoặc liên hệ đến đầu số 02836362900 để được hỗ trợ")]), _vm._v(" "), _c('a', {
    on: {
      "click": _vm.goHome
    }
  }, [_vm._v(" >> Bỏ qua")])])])
},staticRenderFns: []}

/***/ }),

/***/ 928:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-form', {
    ref: "userInfo",
    attrs: {
      "label-width": "150px",
      "model": _vm.userInfo,
      "rules": _vm.userInfoRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Tên đăng nhập",
      "prop": "account"
    }
  }, [_c('el-input', {
    staticClass: "col-10",
    attrs: {
      "name": "name"
    },
    model: {
      value: (_vm.userInfo.account),
      callback: function($$v) {
        _vm.userInfo.account = $$v
      },
      expression: "userInfo.account"
    }
  })], 1), _c('el-form-item', {
    attrs: {
      "label": "Mật khẩu",
      "prop": "password"
    }
  }, [_c('el-input', {
    staticClass: "col-10",
    attrs: {
      "type": "password",
      "name": "password"
    },
    model: {
      value: (_vm.userInfo.password),
      callback: function($$v) {
        _vm.userInfo.password = $$v
      },
      expression: "userInfo.password"
    }
  })], 1), _c('el-form-item', {
    attrs: {
      "label": "Nhập lại mật khẩu",
      "prop": "passwordRepeat"
    }
  }, [_c('el-input', {
    staticClass: "col-10",
    attrs: {
      "type": "password",
      "name": "passwordRepeat"
    },
    model: {
      value: (_vm.userInfo.passwordRepeat),
      callback: function($$v) {
        _vm.userInfo.passwordRepeat = $$v
      },
      expression: "userInfo.passwordRepeat"
    }
  })], 1), _c('el-form-item', {
    staticClass: "mb0"
  }, [_c('div', {
    staticClass: "col-10"
  }, [_c('el-button', {
    staticClass: "col-12",
    attrs: {
      "type": "danger",
      "loading": _vm.loading
    },
    on: {
      "click": _vm.handleSignup
    }
  }, [_vm._v("Đăng ký")])], 1)])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 929:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('download'), _c('div', {
    staticClass: "layout p1 m1 border flex"
  }, [_c('div', {
    staticClass: "flex-auto pr1 mr1 border-right border-color"
  }, [_c('div', {
    staticClass: "flex items-start"
  }, [_c('div', {
    staticClass: "col-8"
  }, [_c('swiper', {
    attrs: {
      "data": _vm.dataCarousel
    }
  }), _c('side-bottom-list', {
    attrs: {
      "data": _vm.dataSideBottom
    }
  })], 1), _c('div', {
    staticClass: "col-4 pl2"
  }, [_c('side-right-list', {
    staticClass: "mt0",
    attrs: {
      "data": _vm.dataSide
    }
  })], 1)]), _c('detail-list', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.dataDetail.length > 0),
      expression: "dataDetail.length > 0"
    }],
    staticClass: "border-top border-color",
    attrs: {
      "data": _vm.dataDetail
    }
  }), _c('classify-list', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.dataPrimary.length > 0),
      expression: "dataPrimary.length > 0"
    }],
    staticClass: "border-top border-color",
    attrs: {
      "data": _vm.dataPrimary,
      "keys": _vm.dataPrimaryKeys,
      "cids": _vm.cids
    }
  })], 1), _c('div', {
    staticStyle: {
      "width": "300px",
      "min-width": "300px"
    }
  }, [_c('admzone'), _c('sticky-list', {
    attrs: {
      "data": _vm.dataSticky
    }
  }), _c('AdTrue')], 1)])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 930:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', [_c('div', {
    staticClass: "header-top flex items-end justify-between"
  }, [_c('router-link', {
    attrs: {
      "to": {
        path: '/'
      }
    }
  }, [_c('div', {
    staticClass: "logo"
  })]), _vm._m(0), _c('div', {
    staticClass: "flex items-end"
  }, [_c('div', {
    staticClass: "date caps mr3"
  }, [_vm._v(_vm._s(_vm.curDate))]), (_vm.isLogin) ? [_c('span', {
    staticClass: "user-name truncate",
    attrs: {
      "title": _vm.userName
    }
  }, [_vm._v(_vm._s(_vm.userName))]), _c('span', {
    staticClass: "btn",
    on: {
      "click": _vm.publish
    }
  }, [_vm._v("Đăng bài")]), _c('ul', {
    staticClass: "person-panel"
  })] : _vm._e()], 2)], 1), _c('nav', [_c('ul', {
    staticClass: "nav-list my0 list-reset flex justify-between"
  }, _vm._l((_vm.navList), function(item, idx) {
    return _c('router-link', {
      key: idx,
      staticClass: "truncate",
      class: parseInt(_vm.$route.query.id) === item.cid ? 'active' : !_vm.$route.query.id && idx === 0 ? 'active' : '',
      attrs: {
        "to": idx === 0 ? {
          path: '/'
        } : {
          path: '/',
          query: {
            id: item.cid
          }
        },
        "tag": "li"
      }
    }, [_vm._v(_vm._s(item.label))])
  }))])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "download",
    attrs: {
      "href": "https://play.google.com/store/apps/details?id=com.thtopnews.app",
      "alt": "",
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_c('div', {
    staticClass: "download-googleplay"
  })])
}]}

/***/ }),

/***/ 931:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "side-bottom-list list-reset flex flex-wrap items-start"
  }, _vm._l((_vm.data), function(item, idx) {
    return _c('li', {
      key: item.id,
      staticClass: "col-6 flex items-start justify-between"
    }, [_c('div', {
      staticClass: "col-5 primary-img relative",
      attrs: {
        "data-ratio": "16/9"
      }
    }, [_c('a', {
      attrs: {
        "href": item.origin_url,
        "target": "_blank"
      }
    }, [_c('img', {
      staticClass: "fit",
      attrs: {
        "src": _vm.shift(item.o_pic_list[0])
      }
    })])]), _c('div', {
      staticClass: "col-7 primary-info px1"
    }, [_c('a', {
      attrs: {
        "href": item.origin_url,
        "target": "_blank"
      }
    }, [_c('div', {
      staticClass: "item-title fs-14",
      attrs: {
        "title": item.title,
        "data-clamp": "3"
      }
    }, [_vm._v(_vm._s(item.title))])]), _c('div', {
      staticClass: "sub col-12"
    }, [_vm._v(_vm._s(item.pub_source)), _c('span', {
      staticClass: "px1"
    }, [_vm._v("|")]), _vm._v(_vm._s(_vm.formatUtc(item.pub_utc)))])])])
  }))
},staticRenderFns: []}

/***/ }),

/***/ 932:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publishNews"
  }, [_c('el-form', {
    ref: "form",
    attrs: {
      "model": _vm.form,
      "label-position": 'top',
      "label-width": "150px",
      "width": "500px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Nhập tiêu đề:"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.title),
      callback: function($$v) {
        _vm.title = $$v
      },
      expression: "title"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Nhập nội dung:"
    }
  }, [_c('vue-editor', {
    model: {
      value: (_vm.content),
      callback: function($$v) {
        _vm.content = $$v
      },
      expression: "content"
    }
  })], 1), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.onSubmit
    }
  }, [_vm._v("submit")])], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 933:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "mt0 list-reset primary-list"
  }, _vm._l((_vm.data), function(item, idx) {
    return _c('li', {
      key: item.id,
      staticClass: "list-item flex my2"
    }, [_c('div', {
      staticClass: "primary-img col-4 overflow-hidden",
      attrs: {
        "data-ratio": "16/9"
      }
    }, [_c('a', {
      attrs: {
        "href": item.origin_url,
        "target": "_blank"
      }
    }, [_c('img', {
      directives: [{
        name: "lazy",
        rawName: "v-lazy",
        value: (_vm.shift(item.o_pic_list[0])),
        expression: "shift(item.o_pic_list[0])"
      }],
      staticClass: "fit"
    })])]), _c('div', {
      staticClass: "primary-info col-8 px2 pb2 flex flex-column items-start justify-between"
    }, [_c('a', {
      attrs: {
        "href": item.origin_url,
        "target": "_blank"
      }
    }, [_c('div', {
      staticClass: "mt0 mb1 item-title",
      attrs: {
        "title": item.title,
        "data-clamp": "3"
      }
    }, [_vm._v(_vm._s(item.title))])]), _c('p', {
      attrs: {
        "data-clamp": "3"
      }
    }, [_vm._v(_vm._s(item.summary))]), _c('div', {
      staticClass: "sub col-12"
    }, [_vm._v(_vm._s(item.pub_source)), _c('span', {
      staticClass: "px1"
    }, [_vm._v("|")]), _vm._v(_vm._s(_vm.formatUtc(item.pub_utc)))])])])
  }))
},staticRenderFns: []}

/***/ }),

/***/ 934:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.slideClass
  }, [_vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),

/***/ 935:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content flex flex-wrap"
  }, _vm._l((_vm.data), function(column, colIdx) {
    return _c('ul', {
      staticClass: "col-4 px1 classify-list list-reset flex flex-column"
    }, _vm._l((column), function(columnItem, rowIdx) {
      return _c('li', {
        staticClass: "classify-item pt2"
      }, [_c('div', {
        staticClass: "top"
      }, [_c('router-link', {
        attrs: {
          "to": _vm.keys[colIdx][rowIdx] === 0 ? {
            path: '/'
          } : {
            path: '/',
            query: {
              id: _vm.keys[colIdx][rowIdx]
            }
          }
        }
      }, [_vm._v(_vm._s(_vm.cidsObj[_vm.keys[colIdx][rowIdx]]))])], 1), _c('ul', {
        staticClass: "primary-list list-reset mt1 mb0 flex flex-column"
      }, _vm._l((columnItem), function(item, idx) {
        return _c('li', {
          key: item.id,
          class: idx === 0 ? 'border-bottom' : null
        }, [(idx === 0) ? _c('div', {
          staticClass: "primary-img col-12 relative",
          attrs: {
            "data-ratio": "16/9"
          }
        }, [_c('a', {
          attrs: {
            "href": item.origin_url,
            "target": "_blank"
          }
        }, [_c('img', {
          staticClass: "fit",
          attrs: {
            "src": _vm.shift(item.o_pic_list[0])
          }
        })])]) : _vm._e(), _c('div', {
          staticClass: "primary-info py1"
        }, [_c('a', {
          attrs: {
            "href": item.origin_url,
            "target": "_blank"
          }
        }, [_c('div', {
          staticClass: "item-title",
          attrs: {
            "title": item.title,
            "data-clamp": idx === 0 ? 3 : 2
          }
        }, [_vm._v(_vm._s(item.title))])]), _c('div', {
          staticClass: "sub col-12"
        }, [_vm._v(_vm._s(item.pub_source)), _c('span', {
          staticClass: "px1"
        }, [_vm._v("|")]), _vm._v(_vm._s(_vm.formatUtc(item.pub_utc)))])])])
      }))])
    }))
  }))
},staticRenderFns: []}

/***/ }),

/***/ 948:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./login.vue": 901,
	"./signup.vue": 902,
	"./signupSuccess.vue": 903
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 948;

/***/ }),

/***/ 949:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 950:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(219);
module.exports = __webpack_require__(343);


/***/ })

},[950]);


// WEBPACK FOOTER //
// js/app.fb74ffcedcd2f56fb474.js